webpackJsonp([26],{

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(54);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _BaseVueOptions = __webpack_require__(2);

var _BaseVueOptions2 = _interopRequireDefault(_BaseVueOptions);

var _CommonUtils = __webpack_require__(3);

var _CookieUtils = __webpack_require__(6);

var _CookieUtils2 = _interopRequireDefault(_CookieUtils);

var _LocalStorageUtils = __webpack_require__(64);

var _LocalStorageUtils2 = _interopRequireDefault(_LocalStorageUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CUSTOMER_TYPE = {
  DCF: 'DCF',
  ORG: 'ORG',
  CORE_CUSTOMER: 'CORE_CUSTOMER',
  CHAIN_CUSTOMER: 'CHAIN_CUSTOMER' };

function getAuthString(loginInfo) {
  var auth = [];
  if (loginInfo) {
    auth.push(loginInfo.authType);
    auth.push('|');
    auth.push(loginInfo.superAdmin ? '1' : '0');
    auth.push('|');

    if (loginInfo.roleIds) {
      auth.push(loginInfo.roleIds.join('`'));
      auth.push('|');
      auth.push(loginInfo.permissionCodes.join('`'));
    }

    return auth.join('');
  } else {
    return null;
  }
}

function getMainDomain() {
  var mainDomain = null;
  var hostName = _CommonUtils.win.getLocation().hostname;
  var domainSplit = hostName.split('.');
  if (domainSplit.length >= 3) {
    var sectionList = [];
    var skipStep = domainSplit.length - 2;
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i]);
    }

    mainDomain = sectionList.join('.');
  } else {
    mainDomain = 'localhost';
  }
  return mainDomain;
}

function getServiceCode(service) {
  var code = [];
  if (service) {
    for (var i = 0; i < service.length; i++) {
      code.push(service[i].serviceCode);
    }
  }

  return code.join('|');
}

function setCookies(loginInfo, isSwitch) {
  var mainDomain = getMainDomain();
  var customizedLogo = (0, _CommonUtils.getQueryString)('c');

  _CookieUtils2.default.set('auth', getAuthString(loginInfo), {
    domain: mainDomain
  });
  _CookieUtils2.default.set('serviceCode', getServiceCode(loginInfo.customerServiceList), {
    domain: mainDomain
  });
  _CookieUtils2.default.set('tk', loginInfo.token, {
    domain: mainDomain
  });
  _CookieUtils2.default.set('userKey', loginInfo.userId, {
    domain: mainDomain
  });
  _CookieUtils2.default.set('cellphone', loginInfo.cellphone, {
    domain: mainDomain
  });
  _CookieUtils2.default.set('customerName', encodeURI(loginInfo.customerName), {
    domain: mainDomain
  });
  if (loginInfo.project) {
    _CookieUtils2.default.set('contractIds', loginInfo.project.contractId, {
      domain: mainDomain
    });
    _CookieUtils2.default.set('projectName', escape(loginInfo.project.projectName) || '', {
      domain: mainDomain
    });
    if (loginInfo.project.role === 1) {
      if (loginInfo.project.isBuyer) {
        _CookieUtils2.default.set('currentRole', 'coreBuyer', {
          domain: mainDomain
        });
      } else {
        _CookieUtils2.default.set('currentRole', 'coreSaller', {
          domain: mainDomain
        });
      }
    } else if (loginInfo.project.role === 2) {
      if (loginInfo.project.isBuyer) {
        _CookieUtils2.default.set('currentRole', 'chainBuyer', {
          domain: mainDomain
        });
      } else {
        _CookieUtils2.default.set('currentRole', 'chainSaller', {
          domain: mainDomain
        });
      }
    }
  }
  if (!isSwitch) {
    _CookieUtils2.default.set('coreLogo', customizedLogo, {
      domain: mainDomain
    });
    if (window.top !== window) {
      var redirectUrl = decodeURIComponent((0, _CommonUtils.getQueryString)('backUrl'));
      _CookieUtils2.default.set('redirectUrl', redirectUrl, {
        domain: mainDomain
      });
    }
  }
}

function refreshStorage(info) {
  _LocalStorageUtils2.default.set('userName', info.userName);
  _LocalStorageUtils2.default.set('customerName', info.customerName);
  _LocalStorageUtils2.default.set('customerId', info.customerId);
  if (info.project) {
    _LocalStorageUtils2.default.remove('projectName');
    _LocalStorageUtils2.default.remove('contractIds');
    _LocalStorageUtils2.default.remove('projectTime');
    _LocalStorageUtils2.default.set('projectName', info.project.projectName);
    _LocalStorageUtils2.default.set('contractIds', info.project.contractId);
    _LocalStorageUtils2.default.set('projectTime', info.project.createTime);
  }
}

function getProject(vm) {
  vm.ajax({
    url: '/api/contract/getProject?timestamp=' + new Date().getTime(),
    type: 'GET',
    success: function success(res) {
      var data = res.body;
      if (data.ret === 1 && data.result) {
        var projectList = data.result || [];
        var result = data.result;
        if (projectList.length === 1) {
          _LocalStorageUtils2.default.set('projectName', result[0].projectName || '');
          _LocalStorageUtils2.default.set('contractIds', result[0].coreContractIdList.join(','));
          _LocalStorageUtils2.default.set('projectTime', result[0].createTime);

          if (!result[0].isBuyer) {
            goTo('/dcf/core1N.html#/index');
          } else {
            goTo(vm.homeHostUrl + '/view/');
          }
        } else {
          goTo('/dcf/core1N.html#/project');
        }
      }
    }
  });
}

function coreSelectIndex(vm, info) {
  if (info.project) {
    if (info.project.role === 1) {
      if (info.project.isBuyer) {
        goTo(vm.homeHostUrl + '/view/');
      } else {
        goTo('/dcf/core1N.html#/index');
      }
    }
    return;
  }

  var isBeforeCustomer = _LocalStorageUtils2.default.get('customerId') === info.customerId;

  var originUrl = (0, _CommonUtils.getQueryString)('os_destination');

  if (isBeforeCustomer && originUrl) {
    window.location.href = originUrl + (window.location.hash || '');
    return;
  } else {
    _LocalStorageUtils2.default.remove('projectName');
    _LocalStorageUtils2.default.remove('contractIds');
    _LocalStorageUtils2.default.remove('projectTime');
  }
  vm.ajax({
    url: '/v1/loan/customer/get',
    type: 'GET',
    success: function success(res) {
      var data = res.body;
      if (data.ret === 1 && data.result) {
        var result = data.result;

        var contractList = (result.contractList || []).concat(result.authorizationContractList || []);
        if (contractList && contractList.length > 0) {
          var customerRole = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(contractList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var contract = _step.value;

              if (contract.isCore && contract.isBuyer) {
                customerRole.push('coreBuyer');
              } else if (contract.isCore && !contract.isBuyer) {
                customerRole.push('coreSeller');
              } else if (!contract.isCore && contract.isBuyer) {
                customerRole.push('chainBuyer');
              } else if (!contract.isCore && !contract.isBuyer) {
                customerRole.push('chainSeller');
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _LocalStorageUtils2.default.set('customerRole', customerRole.join('|'));

          if (customerRole.indexOf('coreSeller') > -1) {
            getProject(vm);
          } else {
            goTo(vm.homeHostUrl + '/view/');
          }
        } else {
          goTo('/dcf/core1N.html#/index');
        }
      }
    }
  });
}

function goTo(url) {
  var customizedLogo = (0, _CommonUtils.getQueryString)('c');
  var openInCurrentPage = (0, _CommonUtils.getQueryString)('o');

  if (url.indexOf('http') !== 0) {
    url = window.location.origin + url;
  }

  if (customizedLogo && openInCurrentPage) {
    window.location.href = url;
  } else {
    try {
      var topDomain = window.top.location.hostname.split('.').slice(1).join('.');
      var tmpUrl = url.split('.').slice(1).join('.');

      if (tmpUrl.indexOf(topDomain) !== 0 && window.top.location.hostname !== 'localhost') {
        window.location.href = url;
      } else {
        window.location.href = url;
      }
    } catch (e) {
      window.location.href = url;
    }
  }
}

exports.default = {
  extends: _BaseVueOptions2.default,
  methods: {
    loginResolve: function loginResolve(result, isSwitch) {
      var vm = this;
      refreshStorage(result);
      setCookies(result, isSwitch);
      if (!isSwitch) {
        if (result.listCustomerSize > 0 || !result.customerType || result.hasNewCustomers || (0, _CommonUtils.ismobile)()) {
          goTo('/dcf/minisite.html#/bind_customer');
          return;
        }
      }
      switch (result.customerType) {
        case CUSTOMER_TYPE.DCF:
          if (vm.$alert) {
            vm.$alert('请到运营端登录', '提示', {
              confirmButtonText: '确定'
            });
          } else if (typeof vm.errorMsg1 !== 'undefined') {
            vm.errorMsg1 = '请到运营端登录';
            vm.isShowMsg1 = true;
          } else {
            alert('请到运营端登录');
          }
          break;
        case CUSTOMER_TYPE.ORG:
          goTo(vm.homeHostUrl + '/views/institution/index.jsp');
          break;
        case CUSTOMER_TYPE.CORE_CUSTOMER:
          coreSelectIndex(vm, result);
          break;
        case CUSTOMER_TYPE.CHAIN_CUSTOMER:
          goTo(vm.homeHostUrl + '/view/');
          break;
      }
    }
  }
};

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1055:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1074:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1223:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(948)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1283),
  /* scopeId */
  "data-v-230a511e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1224:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(972)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1301),
  /* scopeId */
  "data-v-3d9f9384",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1035)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1354),
  /* scopeId */
  "data-v-6ee2c3d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1226:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(906)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1248),
  /* scopeId */
  "data-v-0419f059",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(960)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1292),
  /* scopeId */
  "data-v-361132aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1068)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1381),
  /* scopeId */
  "data-v-a3359d14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1229:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1331),
  /* scopeId */
  "data-v-5515e29f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(909)
__webpack_require__(910)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1251),
  /* scopeId */
  "data-v-050e07ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1074)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(944)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1278),
  /* scopeId */
  "data-v-2071082e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1034)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1353),
  /* scopeId */
  "data-v-6c58167c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(922)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1260),
  /* scopeId */
  "data-v-0c8e2036",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1026)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1346),
  /* scopeId */
  "data-v-660fae62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(908)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1250),
  /* scopeId */
  "data-v-04dbf450",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(952)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1287),
  /* scopeId */
  "data-v-2a58c9d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    class: ['box', {
      'active': _vm.currPath === '/contact'
    }],
    on: {
      "click": function($event) {
        return _vm.topage('contact')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/contact@2x.png",
      "alt": ""
    }
  }), _vm._v("联系我们\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": _vm.onLogin
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/login@2x.png",
      "alt": ""
    }
  }), _vm._v("登录注册\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/logo_white.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.topage('/')
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.caseList.includes(_vm.currPath)
    }]
  }, [_vm._v("我们的方案\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/core')
      }
    }
  }, [_vm._v("核心企业")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/institution')
      }
    }
  }, [_vm._v("金融机构")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('/chain')
      }
    }
  }, [_vm._v("供应商 / 经销商")])])]), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.advantageList.includes(_vm.currPath)
    }]
  }, [_vm._v("我们的优势\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("供应链金融服务")])])]), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'active': _vm.aboutList.includes(_vm.currPath)
    }]
  }, [_vm._v("关于群星\n        "), _c('div', {
    staticClass: "nav-list"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('about')
      }
    }
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("群星资讯")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入群星")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "product"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h1', [_vm._v("大企业适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("核心端操作平台、woodpecker等产品将结合资金方案等供应链金融服务为您盘活企业现金流。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("核心端操作平台")]), _vm._v(" "), _c('p', [_vm._v("该平台实现供应链融资的全程电子化和全周期管理，核心企业可通过该平台使用群星提供的融资服务和引入的资金，同时通过平台优化信用管理体系及运营效率、提高资金使用率。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'core')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('div', {
    staticClass: "slider-box"
  }, [_c('div', {
    staticClass: "line"
  }, [(_vm.coreShow === 'platform') ? _c('div', {
    staticClass: "active"
  }) : (_vm.coreShow === 'tool') ? _c('div', {
    staticClass: "active",
    style: (_vm.coreShow === 'tool' ? 'top:47px;' : '')
  }) : (_vm.coreShow === 'product') ? _c('div', {
    staticClass: "active",
    style: (_vm.coreShow === 'product' ? 'top:94px;' : '')
  }) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', {
    style: (_vm.coreShow === 'platform' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'platform'
      }
    }
  }, [_vm._v("核心端操作平台")]), _vm._v(" "), _c('li', {
    style: (_vm.coreShow === 'tool' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'tool'
      }
    }
  }, [_vm._v("智能诊断工具")]), _vm._v(" "), _c('li', {
    style: (_vm.coreShow === 'product' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'product'
      }
    }
  }, [_vm._v("数据风控产品")])])]), _vm._v(" "), _c('div', {
    staticClass: "right-img"
  }, [(_vm.coreShow === 'platform') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1@2x.png",
      "alt": "img"
    }
  }) : (_vm.coreShow === 'tool') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2@2x.png",
      "alt": "img"
    }
  }) : (_vm.coreShow === 'product') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3@2x.png",
      "alt": "img"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("银行等金融机构适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("机构端操作平台、Shark等将结合数据分析供应链金融服务为您提供优质企业资源。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("数据风控产品")]), _vm._v(" "), _c('p', [_vm._v("数据风控产品有Viper、Shark，Shark是具有群星特色的行为评分卡，该模型通过捕捉企业的动态行为，可以得到不同等级的信用分数，从而量化风险。供应商和经销商可以通过Shark查看自己的风险级别。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'institution')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('div', {
    staticClass: "slider-box"
  }, [_c('div', {
    staticClass: "line",
    staticStyle: {
      "height": "95px"
    }
  }, [(_vm.institutionShow === 'product') ? _c('div', {
    staticClass: "active"
  }) : (_vm.institutionShow === 'platform') ? _c('div', {
    staticClass: "active",
    style: (_vm.institutionShow === 'platform' ? 'top:47px;' : '')
  }) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', {
    style: (_vm.institutionShow === 'product' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.institutionShow = 'product'
      }
    }
  }, [_vm._v("数据风控产品")]), _vm._v(" "), _c('li', {
    style: (_vm.institutionShow === 'platform' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.institutionShow = 'platform'
      }
    }
  }, [_vm._v("机构端操作平台")])])]), _vm._v(" "), _c('div', {
    staticClass: "right-img"
  }, [(_vm.institutionShow === 'product') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg1@2x.png",
      "alt": "img"
    }
  }) : (_vm.institutionShow === 'platform') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2@2x.png",
      "alt": "img"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("供应商/经销商适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("核心端操作平台将结合链属营销等供应链金融服务为您解决资金难题。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "85px"
    }
  }, [_vm._v("链属端操作平台")]), _vm._v(" "), _c('p', [_vm._v("链属端操作平台实现PC、APP、微信等多终端覆盖，同时优化用户体验，确保供应商和经销商随时随地完成货款结算，享受方便快捷的供应链金融服务。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'chain')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('portal-footer', {
    staticClass: "home-footer",
    attrs: {
      "page": "download-home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("平台产品")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解群星的风控系统\n          "), _c('div', {
    staticClass: "showCompare"
  }, [_c('h1', [_vm._v("与传统风控方式相比，群星金融依托平台大数据风控模型，能更精准、智能地核定企业额度及账期；实时获取供应链中的每一笔数据，确保每一笔采购的真实性；贷款后也可以在线了解企业经营情况，达到监控的目的。")]), _vm._v(" "), _c('h2', [_c('span', [_vm._v("群星大数据风控")]), _vm._v("\n              VS\n              "), _c('strong', [_vm._v("传统风控方式")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-线上企业多维度信息的收集与整合，成本低、效率高")]), _vm._v(" "), _c('strong', [_vm._v("-传统线下繁复的企业调研，投入大、进展缓")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-除企业必要静态资料外，核心企业实时上传与链属企业的贸易流水信息，融资及还款数据，平台可给予企业相应的信用评级等")]), _vm._v(" "), _c('strong', [_vm._v("-仅在企业申请融资时能获得企业的静态资料，如企业财务报表、贸易合同等，部分保理商需支付高昂的成本获取第三方的信用报告")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-监控企业采购、应收账款生成、融资及回款资金的全过程")]), _vm._v(" "), _c('strong', [_vm._v("-不了解企业的真是经营情况，风险不透明、不可控")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-大数据挖掘分析模型、快速分析企业信用，合理推荐企业额度账期")]), _vm._v(" "), _c('strong', [_vm._v("-资料信息多，导致授信审批决策难、决策慢")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', {
    staticStyle: {
      "border": "none",
      "border-right": "1px solid #d6d6d6"
    }
  }, [_vm._v("-贷后管理难，定期确认企业的还款意愿（如电话沟通，邮寄材料）")]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("-提供与企业实时沟通工具，贷款后也可以在线了解企业经营情况")])])])])]), _vm._v(" "), _c('h1', [_vm._v("群星金融拥有专业的产品开发团队，可以提供给供应链各方线上平台服务。")]), _vm._v(" "), _c('h1', [_vm._v("强大的数据风控能力并结合舒适的用户体验，")]), _vm._v(" "), _c('h1', [_vm._v("让您轻松完成简单快捷的线上操作。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1@2x.png",
      "alt": "img"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "process"
  }, [_c('h1', [_vm._v("供应链各方线上平台流程一览")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/products/step@2x.png",
      "alt": "img"
    }
  })])
}]}

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "openlogin"
    }
  }, [(_vm.step1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qrcodeLogin),
      expression: "!qrcodeLogin"
    }],
    staticClass: "login-pc"
  }, [_c('div', {
    staticClass: "tel-contain"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMsg),
      expression: "isShowMsg"
    }],
    staticClass: "error-msg1"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMsg))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel1),
      expression: "tel1"
    }],
    staticClass: "tel",
    attrs: {
      "maxlength": "11",
      "type": "text",
      "name": "",
      "placeholder": "输入手机号码",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.tel1)
    },
    on: {
      "change": _vm.telChangeAction,
      "focus": _vm.telFocusAction,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.telAction.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-step",
    on: {
      "click": _vm.telAction
    }
  }, [_vm._v("继续")])]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qrcodeLogin),
      expression: "!qrcodeLogin"
    }],
    staticClass: "login-pc"
  }, [_c('div', {
    staticClass: "tel-contain1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMsg1),
      expression: "isShowMsg1"
    }],
    staticClass: "error-msg"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg1)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel2),
      expression: "tel2"
    }],
    staticClass: "tel",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "psw-contain"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psw1),
      expression: "psw1"
    }],
    staticClass: "psw",
    attrs: {
      "type": "password",
      "placeholder": "您已注册，请输入密码",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.psw1)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginAction.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psw1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.captchaContainer) ? _c('div', {
    staticClass: "captcha-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "captcha-code",
    attrs: {
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "captcha-img",
    attrs: {
      "src": _vm.catpchaImg
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-next-step",
    on: {
      "click": _vm.loginAction
    }
  }, [_vm._v("继续")]), _vm._v(" "), _c('div', {
    staticClass: "return-back",
    on: {
      "click": _vm.returnBackAction
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forget-psw"
  }, [_c('a', {
    attrs: {
      "href": "dcf/minisite.html#/forget?c=home_fax.png",
      "target": "_blank"
    }
  }, [_vm._v("\n        忘记密码\n      ")])])
}]}

/***/ }),

/***/ 1260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "institution"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("金融机构")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-institution')
      }
    }
  }, [_vm._v("下载方案")])])]), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星为银行带来的价值")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("了解供应链金融线上流程")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("这里有海量优质企业资源")]), _vm._v(" "), _c('h2', [_vm._v("留下您的联系方式，我们的顾问将随时为您提供帮助")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-institution"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-institution"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("群星金融可通过供应链金融方案为核心企业和供应链上小微企业解决融资难融资贵的难题，"), _c('br'), _vm._v("不仅为当地企业整条供应链的健康发展服务，同时也带动了当地银行更好的开展多元化的供应链金融业务，"), _c('br'), _vm._v("增加小微企业开户数和放款量，真正实现多方共赢的局面。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("N+1解决方案")]), _vm._v(" "), _c('h3', [_vm._v("群星金融将供应商与核心企业的应收账款转让给金融机构，金融机构依据核心企业信用状况确定成本，决定是否受让应收账款，受让后给供应商提供融资／现金结算。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("1+N解决方案")]), _vm._v(" "), _c('h3', [_vm._v("群星通过对核心企业的应收账款进行量化分析和资产管理，引入金融机构来购买群星筛选的应收账款资产，不仅可以缓解经销商资金压力，也可提高核心企业销售规模，使供应链各方获得共赢。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("引进大批量中小企业"), _c('br'), _vm._v("完成支小目标")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("享受优质的"), _c('br'), _vm._v("大企业资源")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("免费使用群星金融"), _c('br'), _vm._v("的线上平台")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("改善利润结构"), _c('br'), _vm._v("增加中间性收入")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("我们拥有的资源")]), _vm._v(" "), _c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/ziyuan4@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "anchor"
    }
  }, [_vm._v("……")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "core"
    }
  }, [_vm._m(0), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('div', {
    staticClass: "advantage"
  }, [_vm._m(3)]) : (_vm.active === '1+N') ? _c('div', {
    staticClass: "advantage"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("推荐核心企业使用供应链金融方案，做货款结算的主人")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-chain",
      "roleType": _vm.active
    }
  }), _vm._v(" "), _vm._m(6)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-home",
      "roleType": _vm.active
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("供应商/经销商")]), _vm._v(" "), _c('h2', [_vm._v("帮助供应商／经销商盘活沉淀在供应链中的资产"), _c('br'), _vm._v("让企业平等获得金融服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("N+1解决方案")]), _vm._v(" "), _c('h3', [_vm._v("供应商通过群星金融将与核心企业的应收账款转让给金融机构，从而获得新的融资渠道，降低融资成本。金融机构依据核心企业信用状况来确定成本，核心企业获得更稳定的供应链和额外财务收益。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("1+N解决方案")]), _vm._v(" "), _c('h3', [_vm._v("经销商通过群星金融将与核心企业的应付账款转让给金融机构，延长付款账期，缓解资金压力，缓解赊销负担，同时提高核心企业资金周转率，增加经营性现金。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("供应商可以通过该方案改善如下状况")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("提升供应链竞争力")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("掌握供应链话语权")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("获得财务收益")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("更好的资本市场表现")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("经销商可以通过该方案改善如下状况")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("解除赊销负担")])]), _vm._v(" "), _c('div', [_c('strong', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("延长账期"), _c('br'), _vm._v("缓解资金压力")])]), _vm._v(" "), _c('div', [_c('strong', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("扩大销售规模"), _c('br'), _vm._v("增强议价能力")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("我们的案例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli2@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("……")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h1', [_vm._v("群星金融发展历程")]), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('span', {
    staticClass: "left-arrow",
    on: {
      "click": function($event) {
        _vm.slidRight = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-cover"
  }, [_c('ul', {
    class: _vm.slidRight ? 'slidRight' : ''
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('span', {
    staticClass: "right-arrow",
    on: {
      "click": function($event) {
        _vm.slidRight = true
      }
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("荣誉奖项")]), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }, [_c('el-carousel', {
    attrs: {
      "loop": false,
      "interval": 0,
      "arrow": "always",
      "type": "card",
      "height": "430px",
      "indicator-position": "none"
    }
  }, [_c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "67px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup08@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年04月")]), _vm._v(" "), _c('h2', [_vm._v("首届中国商业保理行业创新奖")]), _vm._v(" "), _c('h3', [_vm._v("中国服务贸易协会商业保理专业委员会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "86px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup07@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年11月")]), _vm._v(" "), _c('h2', [_vm._v("2016德勤-华兴中国明日之星")]), _vm._v(" "), _c('h3', [_vm._v("德勤中国、华兴资本颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "149px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup06@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年11月")]), _vm._v(" "), _c('h2', [_vm._v("第一财经金融价值榜"), _c('br'), _vm._v("“最佳平台科技金融公司”")]), _vm._v(" "), _c('h3', [_vm._v("第一财经颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "141px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup05@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年12月")]), _vm._v(" "), _c('h2', [_vm._v("2016创业黑马TOP100"), _c('br'), _vm._v("“中国最具潜力创业公司”")]), _vm._v(" "), _c('h3', [_vm._v("创业黑马颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "52px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup04@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年03月")]), _vm._v(" "), _c('h2', [_vm._v("2016年度十佳新零售服务商")]), _vm._v(" "), _c('h3', [_vm._v("联商网颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup03@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年06月")]), _vm._v(" "), _c('h2', [_vm._v("十佳互联网金融创新奖")]), _vm._v(" "), _c('h3', [_vm._v("《银行家》颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "124px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup02@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年07月")]), _vm._v(" "), _c('h2', [_vm._v("2017最具成长价值奖")]), _vm._v(" "), _c('h3', [_vm._v("第六届中国财经峰会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "246px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup01@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年09月")]), _vm._v(" "), _c('h2', [_vm._v("金惠奖·普惠金融优秀解决方案")]), _vm._v(" "), _c('h3', [_vm._v("中国普惠金融大会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "136px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup09.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2018年03月")]), _vm._v(" "), _c('h2', [_vm._v("年度金融科技介甫奖")]), _vm._v(" "), _c('h3', [_vm._v("—最具影响力供应链金融服务机构")])])], 1)], 1), _vm._v(" "), _c('h1', [_vm._v("企业文化")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("了解更多")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入我们")])])]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("\n        公司介绍\n        "), _c('span', [_vm._v("什么是供应链金融\n          "), _c('div', {
    staticClass: "dialog"
  }, [_c('h3', [_vm._v("什么是供应链金融？")]), _vm._v(" "), _c('p', [_vm._v("通过银行将核心企业和上下游企业联系在一起，把单个企业的不可控风险转变为供应链企业整体的可控风险，通过立体获取各类信息，将风险控制在最低的金融服务。简单地说，就是提供灵活运用的金融产品和服务的一种融资模式,即把资金作为供应链的一个溶剂，增加其流动性。")])])])]), _vm._v(" "), _c('h2', [_vm._v("一家专注于供应链金融长尾的互联网交易平台")]), _vm._v(" "), _c('h3', [_vm._v("群星金融成立于2013年6月，六年来一直专注于供应链金融长尾市场。"), _c('br'), _vm._v("群星金融以技术为第一驱动力，通过互联网技术与大数据风控，"), _c('br'), _vm._v("让沉积于中小企业的应收账款获得流动性，全面降低中小企业融资成本的同时，"), _c('br'), _vm._v("为参与交易的核心企业，金融机构等多方主体创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/moneyflow@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让核心企业的经营性现金流发挥最大效率的作用")]), _vm._v(" "), _c('aside')]), _vm._v(" "), _c('div', {
    staticClass: "info rongzi"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/rongzi@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让中小供应商享受货款现结解决融资难的问题")]), _vm._v(" "), _c('aside')]), _vm._v(" "), _c('div', {
    staticClass: "info index"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/index@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让银行享受优质企业资源批量解决支小指标")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2013年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.6@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/6")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("群星金融网"), _c('br'), _vm._v("成立并上线")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.10@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/10")]), _vm._v(" "), _c('span', [_vm._v("与交通银行浙江省分行就中小企业产业链融资签署战略协议，推出产品\"E贷链\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "big"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.11@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/11")]), _vm._v(" "), _c('span', [_vm._v("与联想集团、物美集团签署合作协议")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("2014年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#0c70b6"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2014.8@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2014/8")]), _vm._v(" "), _c('span', [_vm._v("获得北极光创投领投，华创资本跟投的500万美元A轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "big",
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "76px"
    },
    attrs: {
      "src": "/imgs/portal/about/2014.9@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2014/9")]), _vm._v(" "), _c('span', [_vm._v("海尔日日顺项目上线放款")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("2015年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#478afd"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2015.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2015/4")]), _vm._v(" "), _c('span', [_vm._v("获得由华创、IDG的2000万美元B轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2016年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "20px auto 10px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/4")]), _vm._v(" "), _c('span', [_vm._v("获得商业保理专业委员会颁发的\"创新奖\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.5@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/5")]), _vm._v(" "), _c('span', [_vm._v("获得由曦域资本领投，深圳前海母基金跟投的1.5亿元B+轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#0c70b6"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.7@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/7")]), _vm._v(" "), _c('span', [_vm._v("累计提供融资突破100亿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#1f5dea"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/11")]), _vm._v(" "), _c('span', [_vm._v("荣获\"2016德勤-华兴中国明日之星\"、第一财经金融价值榜\"最佳平台科技金融公司\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "32px",
      "width": "50px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.12@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/12")]), _vm._v(" "), _c('span', [_vm._v("\"虚拟财务公司\"产品发布，同期荣获\"创业黑马TOP100-中国最具潜力创业公司\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2017年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "23px auto 10px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/3")]), _vm._v(" "), _c('span', [_vm._v("获联商网\"2016年度新零售十佳服务商\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "89px",
      "margin": "65px auto 43px"
    },
    attrs: {
      "src": "/imgs/portal/about/2017.6@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/6")]), _vm._v(" "), _c('span', [_vm._v("荣获《银行家》\"十佳互联网金融创新奖\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/7")]), _vm._v(" "), _c('span', [_vm._v("获第六届中国财经峰会\"2017最具成长价值讲\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2018年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "20px auto 8px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_vm._v("2018/3")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("年度金融科技介甫奖—最具影响力供应链金融服务机构")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "life"
  }, [_c('span', [_c('div', [_vm._v("我们的圣诞派对"), _c('br'), _vm._v("派发圣诞礼物")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的群星漫画集"), _c('br'), _vm._v("“群小星来啦”")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的季度总结大会"), _c('br'), _vm._v("CEO演讲")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的户外旅途"), _c('br'), _vm._v("三清山之旅")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的周年庆典"), _c('br'), _vm._v("活动庆典")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的公司内刊"), _c('br'), _vm._v("星迹杂志")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的群星峰会"), _c('br'), _vm._v("活动现场")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的业余生活"), _c('br'), _vm._v("群星电竞比赛")])])])
}]}

/***/ }),

/***/ 1287:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "service"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("\n        供应链金融服务\n        "), _c('span', [_vm._v("成本和收益\n          "), _c('div', {
    staticClass: "dialog"
  }, [_c('h3', [_vm._v("核心无需实际承担财务费用，由现金折扣获得的收益来覆盖")]), _vm._v(" "), _c('p', [_vm._v("资金方和平台是需要收取利息手续费的。那这部分钱谁出呢？以现金采购方案为例，供应商在选择提早拿到货款时可以给核心企业打个折扣。利息和手续费可以根据实际情况，由核心和供应商进行商谈。")]), _vm._v(" "), _c('h4', [_vm._v("举个例子：")]), _vm._v(" "), _c('h5', [_c('i', [_vm._v("假设供应商愿意给到的折扣是95折。")]), _c('br'), _c('i', [_vm._v("即100块钱的货款，供应商支付给核心5元的成本，换取3个月的账期。")]), _c('br'), _c('i', [_vm._v("而核心企业的需要支付给资金方和平台的费率是年化10%。")]), _c('br'), _c('i', [_vm._v("核心成本：95*10%/12*3=2.375元。")]), _c('br'), _c('i', [_vm._v("所以说在支付完资金方和平台费用之后，核心还有收益2.625元。")])]), _vm._v(" "), _c('p', [_vm._v("综上，在现金采购方案中核心"), _c('strong', [_vm._v("无需承担任何实际成本")]), _vm._v("。同时供应商也满足了自己的诉求。")])])])]), _vm._v(" "), _c('h2', [_vm._v("每个企业及其供应商都是独一无二的。因此，您的供应链金融方案的要求和计划执行也将是独一无二的。"), _c('br'), _vm._v("群星会提供灵活，可扩展的解决方案，"), _c('br'), _vm._v("根据您的营运资金目标量身定制，同时支持上下游供应商／经销商的应收账款转让服务。")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/zijin_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("资金方案"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("资金方案服务"), _c('span', [_vm._v("群星利用自身的资源和专业化能力，依据核心企业的需求、市场状况，设计产业链融资方案，并结合上述大数据分析筛选的结果，为核心企业在市场上寻找匹配的资金合作渠道，确定与资金合作渠道的合作流程、价格、设计方案。")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/data_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("数据分析"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("数据分析服务"), _c('span', [_vm._v("群星金融运用大数据分析系统、机器学习、人工智能等新技术，对核心企业提供的应付账款进行准确分类、应用量化模型，筛选出可提供融资服务的上游企业准入清单，测算出相关的风险控制参数（如授信额度等）")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/lianshu_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("链属营销"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("链属营销服务"), _c('span', [_vm._v("依托互联网营销平台和社会化营销工具，群星金融提供快速高效的产业链融资信息传播、客户营销服务，从而给核心企业创造最大的价值。")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/line_2@2x.png",
      "alt": "icon"
    }
  }), _vm._v("线上平台"), _c('div', {
    staticClass: "hover-show"
  }, [_vm._v("线上平台服务"), _c('span', [_vm._v("群星依托其自动化运营系统为用户提供全程电子化、自动化运营操作功能（包括认证、签约、融资申请、融资发放、还款核销、资金监管等），以帮助核心企业及其上游供应商快速便捷地从资金方获得融资服务。")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星金融白皮书"), _c('span', [_vm._v("无论您的公司是供应链金融新手还是熟悉流程，我们的白皮书都可以为您提供更多信息，帮助您提高供应链金融方案的成功率。")])]), _vm._v(" "), _c('a', {
    staticClass: "file",
    attrs: {
      "href": "/pdf/portal/群星金融产品白皮书.zip"
    }
  }, [_c('span', [_vm._v("下载白皮书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/download@2x.png",
      "alt": "icon"
    }
  })])])])
}]}

/***/ }),

/***/ 1292:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "home-character"
  }, [_c('h1', [_vm._v("盘活企业现金流")]), _vm._v(" "), _c('h2', [_vm._v("降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("我是大型企业")]), _vm._v(" "), _c('p', [_vm._v("我要盘活企业现金流，降低供应链中的成本")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', 'form')
      }
    }
  }, [_vm._v("联系顾问团")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("我是银行")]), _vm._v(" "), _c('p', [_vm._v("我要为优质企业提供资金，完成支小目标")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution', 'form')
      }
    }
  }, [_vm._v("联系资金组")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "home-win"
  }, [_c('h1', {
    staticClass: "large"
  }, [_vm._v("享受共赢")]), _vm._v(" "), _c('h2', [_vm._v("降低供应链中的成本，提升整体资金周转效率，为供应链各方创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是大型企业")]), _vm._v(" "), _c('p', [_vm._v("企业等同于获得一张“信用卡”")]), _vm._v(" "), _c('p', [_vm._v("在获得经营性现金流的同时，不占用贷款和发债额度")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', 'n1')
      }
    }
  }, [_vm._v("我想延长供应商账期")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('core', '1n')
      }
    }
  }, [_vm._v("我想提前收取经销商货款")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/visa@2x.png",
      "alt": "icon",
      "width": "240"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是银行")]), _vm._v(" "), _c('p', [_vm._v("响应国务院政策，完成中小微企业新开户数")]), _vm._v(" "), _c('p', [_vm._v("以及给中小微企业放款金额的指标")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("我想开展供应链金融业务")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/bank@2x.png",
      "alt": "icon",
      "width": "280"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我是供应商/经销商")]), _vm._v(" "), _c('p', [_vm._v("享受货款现结，延长账期")]), _vm._v(" "), _c('p', [_vm._v("扩大销售规模，无需再面对资金难题")]), _vm._v(" "), _c('div', {
    staticClass: "a-container"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('chain', 'n1')
      }
    }
  }, [_vm._v("我想提前收到货款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('chain', '1n')
      }
    }
  }, [_vm._v("我想延长付款账期")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/iphone@2x.png",
      "alt": "icon",
      "width": "270"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "home-service"
  }, [_c('h1', {
    staticClass: "large"
  }, [_vm._v("全方位的供应链金融服务")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    staticClass: "home-map"
  }, [_c('header', [_c('h1', [_vm._v("目前有80个省市的数万家中小企业使用群星平台")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/map@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("现在开始体验供应链金融服务")]), _vm._v(" "), _c('div', {
    staticClass: "download",
    on: {
      "click": function($event) {
        return _vm.topage('download?page=download-home')
      }
    }
  }, [_c('span', [_vm._v("下载方案")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/home/download@2x.png",
      "alt": "icon"
    }
  })])]), _vm._v(" "), _c('Footer', {
    staticClass: "home-footer",
    attrs: {
      "page": "download-home"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home-case"
  }, [_c('h1', [_vm._v("专业团队&灵活方案")]), _vm._v(" "), _c('h2', [_vm._v("作为专注于供应链金融长尾的互联网交易平台，群星的团队拥有业内丰富的经验，")]), _vm._v(" "), _c('h2', [_vm._v("能够提供灵活的资金解决方案，您也将享受到其他金融公司无法支持的供应链金融服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home-digit"
  }, [_c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("154")]), _vm._v("家核心\n        "), _c('p', [_vm._v("多家核心企业在使用")]), _vm._v(" "), _c('p', [_vm._v("供应链金融平台")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("80")]), _vm._v("个省市\n        "), _c('p', [_vm._v("数万家企业和供应商")]), _vm._v(" "), _c('p', [_vm._v("享受群星平台服务")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("6")]), _vm._v("年经验\n        "), _c('p', [_vm._v("深耕多年的")]), _vm._v(" "), _c('p', [_vm._v("供应链金融业务经验")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v("130")]), _vm._v("亿元\n        "), _c('p', [_vm._v("群星金融贸易流量")]), _vm._v(" "), _c('p', [_vm._v("已达到130亿元")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/zijin_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("资金方案")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/data_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("数据分析")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/lianshu_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("链属营销")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/home/line_1@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("线上平台")])])])
}]}

/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copy-right"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/imgs/portal/logo_color.png",
      "alt": "logo"
    }
  }), _vm._v("Copyright © 2013-" + _vm._s(new Date().getFullYear())), _c('span', [_vm._v(" 鼎程（上海）金融信息服务有限公司 ")]), _vm._v("致电：400-622-8098"), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("群星金融")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('about')
      }
    }
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("群星资讯")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("快速入口")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("供应链金融服务")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('download')
      }
    }
  }, [_vm._v("下载方案")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("下载白皮书")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("供应链角色")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('core')
      }
    }
  }, [_vm._v("我是上市公司")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("我是金融机构")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', 'n1')
      }
    }
  }, [_vm._v("我是供应商")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', '1n')
      }
    }
  }, [_vm._v("我是经销商")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("其他")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入群星")])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("沪ICP备14012246号-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_vm._v("关注群星金融公众号"), _c('br'), _vm._v("了解一手供应链金融资讯")])
}]}

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('section', [_c('div', {
    staticClass: "cover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('h1', [_vm._v("联系我们")]), _vm._v(" "), _c('el-input', {
    staticClass: "user-name",
    attrs: {
      "placeholder": "怎么称呼您"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择问题类型"
    },
    model: {
      value: (_vm.questionType),
      callback: function($$v) {
        _vm.questionType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "questionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "融资问题",
      "value": "融资问题"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "供应商注册问题",
      "value": "供应商注册问题"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "银行或其他金融机构",
      "value": "银行或其他金融机构"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "企业推荐",
      "value": "企业推荐"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "客户手机号或邮箱"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "您的公司名称"
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyName"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "问题描述"
    },
    model: {
      value: (_vm.questionDetail),
      callback: function($$v) {
        _vm.questionDetail = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "questionDetail"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("提交")])], 1)])]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address', [_c('h1', [_vm._v("您可以填写右边的表格，我们会尽快与您联系。您也可以按照以下电话和地址与我们取得联系。")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("400-622-8098")]), _vm._v(" "), _c('div', {
    staticClass: "mes"
  }, [_vm._v("200030")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v("上海市徐汇区中山南二路107号"), _c('br'), _vm._v("美奂大厦11层A单元")]), _vm._v(" "), _c('h2', [_vm._v("在地图上找我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://map.baidu.com/?newmap=1&s=inf%26uid%3D11f3652ca38d1d70077ce835%26wd%3D%E7%BE%8E%E5%A5%82%E5%A4%A7%E5%8E%A6%26all%3D1%26c%3D289&from=alamap&tpl=map_singlepoint",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "map",
    attrs: {
      "src": "/imgs/portal/contact/shanghai@2x.jpg",
      "alt": "map"
    }
  })])])
}]}

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_vm._m(0), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("群星资讯 Newsroom")]), _vm._v(" "), _c('div', {
    staticClass: "main news-001"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485957&idx=1&sn=aea677a51a47a5dd56cee9eee3dd7fe9&chksm=f962563ece15df28df9975f4fcbed012f7cf1a0793aaac69650adb85611b668237204dadc2d8&mpshare=1&scene=1&srcid=0114kqQ5PHpXrNI0OWgPjJ1u&key=c00f467f1168649cfd1e4209437e7eed81435b5bc8b90af1c6a74fea8e7114338e502dc9183e6290db7e8e3f5598c1ac7913bb30f2b465f9080d407e817b2bb97fb68a624cb26aec9bf52136e737d162&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h2', [_vm._v("2018年全国及各省市供应链金融政策汇总及解读")]), _vm._v(" "), _c('h3', [_vm._v("党中央、国务院高度重视供应链金融工作，围绕供应链金融发展问题国家各部门制定出台了一系列政策措施，将供应链金融作为金融领域改革的重要内容。")]), _vm._v(" "), _c('h5', [_vm._v("2019年1月13日")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-002"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485631&idx=1&sn=e52b19b585c35f0583ef884fe85d5910&chksm=f9625484ce15dd924ecd0779f4594e961945f0347138e955d8ab7e1cf44fee654d4d429ddfc8&mpshare=1&scene=1&srcid=0114Mvl27fSTUXxsZamGoloL&key=bec5e629de7c44219c115bb750613e4bd74c9bb63046873a43ed0e8c47148737bb0f1e6cdf2e3cce7b54524baca63d671db3d4f7482aff8e6982e10dded9fa2e759da06c3641629eb834851170cda623&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("供应链金融—美国的昨天、日本的今天、中国的明天")]), _vm._v(" "), _c('h3', [_vm._v("2018年11月02日")]), _vm._v(" "), _c('h5', [_vm._v("供应链金融起源来自于供应链管理，传统的供应链管理强调“6R”，即将顾客所需的正确的产品能够在正确的时间、按照正确的数量、正确的质量……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-003"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485705&idx=1&sn=d7eb0fde9f8d9465cb7232cd5d2cbc1f&chksm=f9625532ce15dc241317ffbfd639f2451cb9e0a10a57d97b07d371ad10ae6f4be16318b33bbf&mpshare=1&scene=1&srcid=0114Zf6Hye1NxBAya8NaKE1Z&key=908e15f391718e2fea8bf2c3623de3bf84d927c05409e9804f406f99f4f91784bcc8c98df421604ef6bed834d4f1ac43f27b7235e4030b0416fe3e2c920d7dd89958482f67c693b63a2cd6ce5cd0e454&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("2018年供应链金融行业发展趋势报告")]), _vm._v(" "), _c('h3', [_vm._v("2018年11月21日")]), _vm._v(" "), _c('h5', [_vm._v("2018年，供应链金融成了资本眼中的“风口”，一时间，大量企业都蜂拥而至。客观来看，它是实现上至国家、下至地方企业经济转型的重要突破……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-004"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485442&idx=1&sn=4bb95b10d9bdb2561886d6804ba17ff4&chksm=f9625439ce15dd2f077e2757f9b9a37f0623aeb5e63fdd675a4330336a937a2bf9a63ec7de2f&mpshare=1&scene=1&srcid=01145kLicotPb7yuUreg2Tcm&key=97a5648ff70ea34209722cc0c3d3d72edeef8494a7b655b860453f7bd536f0818ee12a5d0dba54a0f524e2b9042b17550e9f5848a72f7f4a01f30b2660355ff35682471c705091dd63c4c2cf08eae541&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("物流领域12大商业模式")]), _vm._v(" "), _c('h3', [_vm._v("2018年09月18日")]), _vm._v(" "), _c('h5', [_vm._v("“真正从运输、仓储运营中赚点辛苦钱”，这是中国物流基层的商业模式，那些跑在路上的卡车司机、蹲在仓库做传统的物流服务模式的企业，这……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-005"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247485009&idx=1&sn=eb7c990a9a26ef21c776ce134714e17d&chksm=f9625a6ace15d37c90567cf7d8359b5a1bc8563d9c0b1af886cc471120539e768afe36d5c30a&mpshare=1&scene=1&srcid=0114jOOHCu8Y9185lLyqYSDt&key=bd6a952ad1769e3ed4b2eb227cc31be2601d64bc84adc6c0350868b91b8b45c5cc8ca96628927c5b5b67d75fea19016950506db407b422fd14b408af5df54dd68a11fff6938bd4d06b16239127d95d86&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("生日快乐呀，群小星！")]), _vm._v(" "), _c('h3', [_vm._v("2018年06月28日")]), _vm._v(" "), _c('h5', [_vm._v("今天是群小星的生日，倏忽间群星金融已经诞生整整五年了。群星“航母”里面的小伙伴们来来又走走。有些人过来推了我一把又离去，成了……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-006"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247484760&idx=1&sn=1cd4e359d2f2e2777c5967261da866fe&chksm=f9625963ce15d075e02a7ff1a24e6b24752490df554ffa08f2c4f97a46b312954affdec74f05&mpshare=1&scene=1&srcid=0114jOIR0TcRDNE775H6f3Ta&key=1af80038efb38668453b118f6affb25c0de89e54e9334a3bf7ecfb575da02c4d2223a76a9125c4e7f5e944bc39013503c1c5196dd52d2fbaa2a84a5192d0b74b2c9d37c9e86bcbc3e9c1984cd055b68f&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("建筑产业链遇上供应链金融，实现多方持续共赢")]), _vm._v(" "), _c('h3', [_vm._v("2018年05月17日")]), _vm._v(" "), _c('h5', [_vm._v("5月11日的界面资本论坛上，华建集团副总裁周静瑜受邀出席圆桌论坛，阐述了4年前对一家位列全球前三的美国室内设计公司——威尔逊……")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other news-007"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzUxMjUyNzcwMA==&mid=2247484593&idx=1&sn=a89329d4b9bd2e8f39f9be00f6c0ab2f&chksm=f962588ace15d19caf7953e1286b044f76327cff0ef62f6e24f16463cc88b2c1e4b3eeeeec75&mpshare=1&scene=1&srcid=0114VqJazvBG5Fu4w3yqXmjj&key=fdbd38954fdfc514a886025914e1549f2481cd624fcf90d9bbf0211757d34e7d65e0d63b3d1e07ef8e2f8c341a25297dffd09abf1a87e61aaf0f471aaaa747c735679892a7de4459ebaa99e734d61068&ascene=0&uin=MjQyNTczMTkxMw%3D%3D&devicetype=iMac+MacBookPro12%2C1+OSX+OSX+10.12.6+build",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h2', [_vm._v("一个五年前就开始布的局")]), _vm._v(" "), _c('h3', [_vm._v("2018年04月26日")]), _vm._v(" "), _c('h5', [_vm._v("京东、苏宁、腾讯对供应链金融的重视和布局，充分显示出沉寂一年多的供应链金融出现了回暖的趋势。无论是传统商业银行、行业龙头、物流公……")])])])])])
}]}

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copy-right"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/imgs/portal/logo_white.png",
      "alt": "logo"
    }
  }), _vm._v("Copyright © 2013-" + _vm._s(new Date().getFullYear())), _c('span', [_vm._v(" 鼎程（上海）金融信息服务有限公司 ")]), _vm._v("致电：400-622-8098"), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("群星金融")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('about')
      }
    }
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("群星资讯")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("快速入口")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('product')
      }
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("供应链金融服务")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('download')
      }
    }
  }, [_vm._v("下载方案")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("下载白皮书")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("供应链角色")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('core')
      }
    }
  }, [_vm._v("我是上市公司")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('institution')
      }
    }
  }, [_vm._v("我是金融机构")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', 'n1')
      }
    }
  }, [_vm._v("我是供应商")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('chain', '1n')
      }
    }
  }, [_vm._v("我是经销商")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "top"
  }, [_vm._v("其他")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入群星")])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("沪ICP备14012246号-1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_vm._v("关注群星金融公众号"), _c('br'), _vm._v("了解一手供应链金融资讯")])
}]}

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "platform"
    }
  }, [(_vm.roletype === 'core') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_c('span', [_vm._v("平台产品")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'operator' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'operator'
      }
    }
  }, [_vm._v("核心端操作平台")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'tool' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'tool'
      }
    }
  }, [_vm._v("智能诊断工具")]), _vm._v(" "), _c('strong', {
    class: _vm.coreProduct === 'product' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.coreProduct = 'product'
      }
    }
  }, [_vm._v("数据风控产品")])]), _vm._v(" "), (_vm.coreProduct === 'operator') ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.coreProduct === 'tool') ? [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.coreProduct === 'product') ? [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : _vm._e()], 2)]) : (_vm.roletype === 'institution') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "margin-right": "650px"
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('strong', {
    class: _vm.institutionProduct === 'products' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.institutionProduct = 'products'
      }
    }
  }, [_vm._v("数据风控产品")]), _vm._v(" "), _c('strong', {
    class: _vm.institutionProduct === 'platform' ? 'choose' : '',
    on: {
      "click": function($event) {
        _vm.institutionProduct = 'platform'
      }
    }
  }, [_vm._v("机构端操作平台")])]), _vm._v(" "), (_vm.institutionProduct === 'products') ? [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "288px",
      "margin-top": "30px"
    },
    attrs: {
      "src": "/imgs/portal/products/jg1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : (_vm.institutionProduct === 'platform') ? [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2_3@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)] : _vm._e()], 2)]) : (_vm.roletype === 'chain') ? _c('header', [_c('div', {
    staticClass: "cover"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "loop": false,
      "autoplay": false,
      "indicator-position": "outside",
      "height": "420px"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_1@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_2@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1_2@2x.png",
      "alt": "img"
    }
  })])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("立即体验")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "product",
      "roleType": _vm.roletype
    }
  }), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-home",
      "roleType": _vm.roletype
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("业务批量上线；轻松统筹上下游；资金流向一目了然")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("快速了解核心企业基本信息；供应链融资需求诊断；自动化生成推荐方案；方案效果智能可视化；定制化群星方案报告")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("核心企业")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用后台企业预设、用户通过手机号注册登录")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("助缩短项目分析周期；加速资产分析批量化；成为Woodpecker和群星平台的接力站")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("金融机构")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("充分利用机器学习；动态追踪，实时观测风险，预防欺诈；精准区分出风险的高低")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("金融机构")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("风险实时监控；风险可视化；操作便捷")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticStyle: {
      "margin-right": "770px"
    }
  }, [_vm._v("平台产品")]), _vm._v(" "), _c('strong', [_vm._v("链属端操作平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("用户类型")]), _vm._v(" "), _c('h3', [_vm._v("供应商／经销商")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("注册方式")]), _vm._v(" "), _c('h3', [_vm._v("采用手机号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('h2', [_vm._v("产品亮点")]), _vm._v(" "), _c('h3', [_vm._v("多终端覆盖；账户体系，款票货一致；操作便捷，一键收款")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}

/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "core"
    }
  }, [_c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("核心企业")]), _vm._v(" "), _c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("如何延长付款账期")]), _vm._v(" "), _c('h3', [_vm._v("群星金融可提供一款“N+1现金采购”的供应链金融解决方案，基于核心企业对应付账款的确认/付款承诺，资金方受让供应商对核心企业的应收账款，给供应商提供融资/现金结算；核心企业可以延长对供应商的付款账期，获得经营性现金流；也可以获取融资利差。")]), _vm._v(" "), _c('h5', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-core')
      }
    }
  }, [_vm._v("下载方案")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("如何提前收取经销商货款")]), _vm._v(" "), _c('h3', [_vm._v("群星通过对核心企业的应收账款进行资产分析，并引入金融机构购买应收账款资产，核心企业可以在风险不变、现金流不变的前提下，拉长给经销商的赊销账期，从而解决经销商的资金压力，帮助核心企业扩大销售规模。")]), _vm._v(" "), _c('h5', {
    on: {
      "click": function($event) {
        return _vm.topage('download', 'download-core')
      }
    }
  }, [_vm._v("下载方案")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("对比银行贷款或发行债券，群星金融方案的优势在于")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("同时，群星会提供基于方案的如下供应链金融服务")]), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        return _vm.topage('service')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("这里有适合您的资金方案")]), _vm._v(" "), _c('h2', [_vm._v("留下您的联系方式，我们的顾问将随时为您提供帮助")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-core",
      "roleType": _vm.active
    }
  }), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-core",
      "roleType": _vm.active
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("获得经营性现金流"), _c('br'), _vm._v("不增加公司有息负债")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("不占贷款和发债额度"), _c('br'), _vm._v("为公司留更多借款空间")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("优化财务报表"), _c('br'), _vm._v("提升供应链整体竞争力")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("融资稳定性更高"), _c('br'), _vm._v("较不宜受市场波动的影响")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('div', [_c('img', {
    staticClass: "img-1",
    attrs: {
      "src": "/imgs/portal/home/zijin_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("资金方案")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-2",
    attrs: {
      "src": "/imgs/portal/home/data_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("数据分析")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-3",
    attrs: {
      "src": "/imgs/portal/home/lianshu_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("链属营销")])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-4",
    attrs: {
      "src": "/imgs/portal/home/line_1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("线上平台")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bank"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-line"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank2@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank4@2x.png",
      "alt": "img"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-line",
    attrs: {
      "id": "anchor"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank5@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank6@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank7@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/bank8@2x.png",
      "alt": "img"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}

/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "download"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [(_vm.page === 'download-home') ? _c('h1', [_vm._v("我们会在24小时内将供应链金融方案发至您的邮箱。")]) : _c('h1', [_vm._v("请选择以下哪种行业适用于您，"), _c('br'), _vm._v("我们会将相关的供应链金融方案发至您的邮箱。")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": _vm.page,
      "roleType": _vm.roleType
    }
  }), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sweet-modal', {
    ref: "loginModal",
    staticClass: "modal-login"
  }, [(_vm.step1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qrcodeLogin),
      expression: "!qrcodeLogin"
    }],
    staticClass: "login-pc"
  }, [_c('div', {
    staticClass: "login-title"
  }, [_vm._v("登录／注册")]), _vm._v(" "), _c('div', {
    staticClass: "tel-contain"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMsg),
      expression: "isShowMsg"
    }],
    staticClass: "error-msg1"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMsg))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel1),
      expression: "tel1"
    }],
    staticClass: "tel",
    attrs: {
      "maxlength": "11",
      "type": "text",
      "name": "",
      "placeholder": "输入手机号码",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.tel1)
    },
    on: {
      "change": _vm.telChangeAction,
      "focus": _vm.telFocusAction,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.telAction.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-step",
    on: {
      "click": _vm.telAction
    }
  }, [_vm._v("继续")])]) : (_vm.step2) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qrcodeLogin),
      expression: "!qrcodeLogin"
    }],
    staticClass: "login-pc"
  }, [_c('div', {
    staticClass: "login-title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "tel-contain1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMsg1),
      expression: "isShowMsg1"
    }],
    staticClass: "error-msg"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg1)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel2),
      expression: "tel2"
    }],
    staticClass: "tel",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "psw-contain"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psw1),
      expression: "psw1"
    }],
    staticClass: "psw",
    attrs: {
      "type": "password",
      "placeholder": "您已注册，请输入密码",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.psw1)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginAction.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psw1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forget-psw"
  }, [_c('a', {
    attrs: {
      "href": "dcf/minisite.html#/forget"
    }
  }, [_vm._v("\n        忘记密码\n      ")])]), _vm._v(" "), (_vm.captchaContainer) ? _c('div', {
    staticClass: "captcha-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    staticClass: "captcha-code",
    attrs: {
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "captcha-img",
    attrs: {
      "src": _vm.catpchaImg
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-next-step",
    on: {
      "click": _vm.loginAction
    }
  }, [_vm._v("继续")]), _vm._v(" "), _c('div', {
    staticClass: "return-back",
    on: {
      "click": _vm.returnBackAction
    }
  })]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qrcodeLogin),
      expression: "!qrcodeLogin"
    }],
    staticClass: "login-pc"
  }, [_c('div', {
    staticClass: "login-title"
  }, [_vm._v("注册")]), _vm._v(" "), _c('div', {
    staticClass: "tel-contain1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMsg2),
      expression: "isShowMsg2"
    }],
    staticClass: "error-msg"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMsg2)
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel2),
      expression: "tel2"
    }],
    staticClass: "tel",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "psw-contain"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psw1),
      expression: "psw1"
    }],
    staticClass: "psw",
    attrs: {
      "type": "password",
      "placeholder": "设置密码(6-20位，数字及字母的组合)",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.psw1)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psw1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "captcha-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perCaptchaCode),
      expression: "perCaptchaCode"
    }],
    staticClass: "captcha-code",
    attrs: {
      "placeholder": "输入验证码"
    },
    domProps: {
      "value": (_vm.perCaptchaCode)
    },
    on: {
      "focus": _vm.telCaptchaFocusAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.perCaptchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-captcha",
    attrs: {
      "disabled": !_vm.isShowCaptcha
    },
    on: {
      "click": _vm.getPerVerifyCaptcha
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCaptcha),
      expression: "isShowCaptcha"
    }]
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowCaptcha),
      expression: "!isShowCaptcha"
    }]
  }, [_vm._v(_vm._s(_vm.count) + "s")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-next-step",
    on: {
      "click": _vm.loginAction
    }
  }, [_vm._v("继续")]), _vm._v(" "), _c('div', {
    staticClass: "return-back",
    on: {
      "click": _vm.returnBackAction
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qrcodeLogin),
      expression: "qrcodeLogin"
    }],
    staticClass: "login-qrcode",
    attrs: {
      "id": "login-qrcode"
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'login_icon': true,
      'qrcode': _vm.qrcodeLogin
    },
    on: {
      "click": function($event) {
        return _vm.toggleLogin()
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "join"
    }
  }, [_c('section', [_c('div', {
    staticClass: "coverheader"
  }, [_c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("加入群星")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "team-type"
  }, [_c('span', {
    class: _vm.teamType === 'dev' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'dev'
      }
    }
  }, [_vm._v("研发团队")]), _vm._v(" "), _c('span', {
    class: _vm.teamType === 'ser' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'ser'
      }
    }
  }, [_vm._v("业务团队")]), _vm._v(" "), _c('span', {
    class: _vm.teamType === 'pro' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'pro'
      }
    }
  }, [_vm._v("产品团队")])]), _vm._v(" "), (_vm.teamType === 'dev') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_developer@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(1)]) : (_vm.teamType === 'ser') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_yewu@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(2)]) : (_vm.teamType === 'pro') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_product@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(3)]) : _vm._e()])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("在群星，各个领域的人才都能大有所为，我们珍视充满热情、勇气和敢于创新的人才。"), _c('br'), _vm._v("我们的每一个团队、每一个角色都需要这样的员工。加入群星，让你成就非凡的职业生涯。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("研发团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("我们的工程师在开发软件时，会时刻关注用户。"), _c('br'), _vm._v("这也是群星平台及APP方便易用的原因。"), _c('br'), _vm._v("未来，他们将依然保持对用户的尊重，并实现更多的创新突破。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4628516.html",
      "target": "_blank"
    }
  }, [_vm._v("JAVA高级研发工程师")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/5009464.html",
      "target": "_blank"
    }
  }, [_vm._v("自动化测试工程师")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "href": "https://www.lagou.com/jobs/4309762.html",
      "target": "_blank"
    }
  }, [_vm._v("中级前端开发工程师")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("业务团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("帮助企业伙伴去思考如何借助供应链金融方案，"), _c('br'), _vm._v("为他们的公司创造更多价值、实现更多可能，并让上下游获得共赢，"), _c('br'), _vm._v("这是成为群星金融顾问的重要价值。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/2507439.html",
      "target": "_blank"
    }
  }, [_vm._v("大客户代表")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4301529.html",
      "target": "_blank"
    }
  }, [_vm._v("资金渠道经理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4032521.html",
      "target": "_blank"
    }
  }, [_vm._v("项目经理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("产品团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("执行非同凡响的标准，"), _c('br'), _vm._v("满足非比寻常的期待。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/3916487.html",
      "target": "_blank"
    }
  }, [_vm._v("产品部门助理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("招聘Q&A")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("我可以通过什么渠道申请岗位？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("您可以直接将简历附件发送至邮箱：zpsh@iqunxing.com"), _c('br'), _vm._v("并备注您意向投递的岗位。若有岗位机会，会优先联系。")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("公司岗位的招聘流程是怎样的？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("简历经过筛选后，HR会沟通面试时间，初次面试通过后方可进行复试"), _c('br'), _vm._v("部分岗位需要进行笔试。具体根据岗位要求而定。")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("公司对新员工有培训么？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("有，新员工入职一个月内进行新员工入职培训(具体时间以邮件为"), _c('br'), _vm._v("准)，后期还会有其他培训，例如技能分享会等等。")])])])])
}]}

/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path.indexOf('/openLogin') === 0) ? _c('div', [_c('router-view')], 1) : _c('div', {
    attrs: {
      "id": "viewPort"
    }
  }, [_c('Header', {
    attrs: {
      "onLogin": _vm.showLoginModal
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "onLogin": _vm.showLoginModal
    }
  })], 1), _vm._v(" "), _c('modal-login', {
    ref: "loginModal"
  }), _vm._v(" "), _c('update-modal')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "form"
    }
  }, [(_vm.from === 'case-core' || _vm.from === 'case-chain' || _vm.from === 'case-institution' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "手机号码或邮箱"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'download-core' || _vm.from === 'download-home' || _vm.from === 'download-institution') ? _c('el-input', {
    attrs: {
      "placeholder": "邮箱地址"
    },
    model: {
      value: (_vm.cellphone),
      callback: function($$v) {
        _vm.cellphone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "cellphone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-core' || _vm.from === 'case-institution' || _vm.from === 'download-home' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "怎么称呼您"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-core' || _vm.from === 'case-chain' || _vm.from === 'download-core' || _vm.from === 'download-home' || _vm.from === 'product') ? _c('el-input', {
    attrs: {
      "placeholder": "您的公司名称"
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-institution' || _vm.from === 'download-institution') ? _c('el-input', {
    attrs: {
      "placeholder": "您所在金融机构名称"
    },
    model: {
      value: (_vm.institutionName),
      callback: function($$v) {
        _vm.institutionName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "institutionName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.from === 'case-chain') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业角色类型"
    },
    model: {
      value: (_vm.companyPart),
      callback: function($$v) {
        _vm.companyPart = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyPart"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "我是经销商",
      "value": "经销商"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是供应商",
      "value": "供应商"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-home') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业类型"
    },
    model: {
      value: (_vm.companyType),
      callback: function($$v) {
        _vm.companyType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "我是上市公司/大型国企",
      "value": "上市公司/大型国企"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是银行",
      "value": "银行"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我是供应商/经销商",
      "value": "供应商/经销商"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-core') ? _c('el-select', {
    attrs: {
      "placeholder": "选择企业行业类型"
    },
    model: {
      value: (_vm.industryType),
      callback: function($$v) {
        _vm.industryType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "industryType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "建筑工程行业",
      "value": "建筑工程行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "医药流通行业",
      "value": "医药流通行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "零售行业",
      "value": "零售行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "新能源行业",
      "value": "新能源行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制造行业",
      "value": "制造行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "物流行业",
      "value": "物流行业"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他行业",
      "value": "其他行业"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.from === 'download-institution') ? _c('el-select', {
    attrs: {
      "placeholder": "您所在金融机构属于"
    },
    model: {
      value: (_vm.institutionPart),
      callback: function($$v) {
        _vm.institutionPart = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "institutionPart"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "银行",
      "value": "银行"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非银行金融机构",
      "value": "非银行金融机构"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    style: (_vm.disabled ? 'background: #6894f9;' : 'background: #1F5DEA;'),
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
	name: 'SweetModal',

	props: {
		title: {
			type: String,
			required: false,
			default: ''
		},

		overlayTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		modalTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		blocking: {
			type: Boolean,
			required: false,
			default: false
		},

		pulseOnBlock: {
			type: Boolean,
			required: false,
			default: true
		},

		icon: {
			type: String,
			required: false,
			default: ''
		},

		hideCloseButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	mounted: function mounted() {
		this.tabs = this.$children.filter(function (c) {
			return c.cmpName && c.cmpName == 'tab';
		});

		if (this.has_tabs) {
			this.currentTab = this._changeTab(this.tabs[0]);
		}

		document.addEventListener('keyup', this._onDocumentKeyup);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keyup', this._onDocumentKeyup);
	},
	data: function data() {
		return {
			visible: false,
			is_open: false,
			is_bouncing: false,
			tabs: [],

			backups: {
				body: {
					height: null,
					overflow: null
				}
			}
		};
	},


	computed: {
		has_title: function has_title() {
			return this.title || this.$slots.title;
		},
		has_tabs: function has_tabs() {
			return this.tabs.length > 0;
		},
		has_content: function has_content() {
			return this.$slots.default;
		},
		current_tab: function current_tab() {
			return this.tabs.filter(function (t) {
				return t.active === true;
			})[0];
		},
		overlay_classes: function overlay_classes() {
			return ['sweet-modal-overlay', 'theme-' + this.overlayTheme, 'sweet-modal-clickable', {
				'is-visible': this.visible,
				blocking: this.blocking
			}];
		},
		modal_classes: function modal_classes() {
			return ['sweet-modal', 'theme-' + this.modalTheme, {
				'has-title': this.has_title,
				'has-tabs': this.has_tabs,
				'has-content': this.has_content,
				'has-icon': this.icon,
				'is-visible': this.visible,
				'sweet-alert': this.icon && !this.has_tabs || !this.icon && !this.title && !this.$slots.title,
				bounce: this.is_bouncing
			}];
		}
	},

	methods: {
		open: function open() {
			var _this = this;

			var tabId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (tabId && this.has_tabs) {
				var openingTabs = this.tabs.filter(function (tab) {
					return tab.id === tabId;
				});
				if (openingTabs.length > 0) {
					this.currentTab = this._changeTab(openingTabs[0]);
				} else {
					var openingTab = this.tabs[tabId];
					if (openingTab) {
						this.currentTab = this._changeTab(openingTab);
					}
				}
			}

			this.is_open = true;
			this._lockBody();
			this._animateIcon();

			setTimeout(function () {
				return _this.visible = true;
			}, 30);
			this.$emit('open');
		},
		close: function close() {
			var _this2 = this;

			this.visible = false;
			this._unlockBody();

			setTimeout(function () {
				return _this2.is_open = false;
			}, 300);
			this.$emit('close');
		},
		bounce: function bounce() {
			var _this3 = this;

			this.is_bouncing = true;

			setTimeout(function () {
				return _this3.is_bouncing = false;
			}, 330);
		},
		_lockBody: function _lockBody() {
			this.backups.body.height = document.body.style.height;
			this.backups.body.overflow = document.body.style.overflow;

			document.body.style.height = '100%';
			document.body.style.overflow = 'hidden';
		},
		_unlockBody: function _unlockBody() {
			document.body.style.height = this.backups.body.height;
			document.body.style.overflow = this.backups.body.overflow;
		},
		_onOverlayClick: function _onOverlayClick(event) {
			if (!event.target.classList || event.target.classList.contains('sweet-modal-clickable')) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_onDocumentKeyup: function _onDocumentKeyup(event) {
			if (event.keyCode == 27) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_changeTab: function _changeTab(tab) {
			this.tabs.map(function (t) {
				return t.active = t == tab;
			});
			this.currentTab = tab;
		},
		_getClassesForTab: function _getClassesForTab(tab) {
			return ['sweet-modal-tab', {
				active: tab.active,
				disabled: tab.disabled
			}];
		},
		_animateIcon: function _animateIcon() {
			var _this4 = this;

			if (!this.icon) return;

			switch (this.icon) {
				case 'success':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_success, {
							'': ['animate'],
							'.sweet-modal-tip': ['animateSuccessTip'],
							'.sweet-modal-long': ['animateSuccessLong']
						});
					}, 80);

					break;

				case 'warning':
					this._applyClasses(this.$refs.icon_warning, {
						'': ['pulseWarning'],
						'.sweet-modal-body': ['pulseWarningIns'],
						'.sweet-modal-dot': ['pulseWarningIns']
					});

					break;

				case 'error':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_error, {
							'': ['animateErrorIcon'],
							'.sweet-modal-x-mark': ['animateXMark']
						});
					}, 80);

					break;
			}
		},
		_applyClasses: function _applyClasses($ref, classMap) {
			for (var cl in classMap) {
				var _$el$classList, _$el$classList2;

				var classes = classMap[cl];
				var $el = void 0;

				if (cl == '') {
					$el = $ref;
				} else {
					$el = $ref.querySelector(cl);
				}

				(_$el$classList = $el.classList).remove.apply(_$el$classList, _toConsumableArray(classes));
				(_$el$classList2 = $el.classList).add.apply(_$el$classList2, _toConsumableArray(classes));
			}
		}
	}
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	props: {
		title: {
			type: String,
			required: true
		},

		id: {
			type: String,
			required: true
		},

		icon: {
			type: String,
			required: false,
			default: null
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function data() {
		return {
			active: false
		};
	},


	computed: {
		cmpName: function cmpName() {
			return 'tab';
		}
	}
};

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1086)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1395),
  /* scopeId */
  "data-v-ed76a51e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    class: _vm.overlay_classes,
    on: {
      "click": _vm._onOverlayClick
    }
  }, [_c('div', {
    class: _vm.modal_classes
  }, [_c('div', {
    staticClass: "sweet-box-actions"
  }, [_vm._t("box-action"), _vm._v(" "), (!_vm.hideCloseButton) ? _c('div', {
    staticClass: "sweet-action-close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#292c34"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.has_title || _vm.has_tabs) ? _c('div', {
    staticClass: "sweet-title"
  }, [(_vm.has_tabs && !_vm.has_title) ? [_c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.has_title) ? [(_vm.title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.has_title && _vm.has_tabs) ? _c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "sweet-content"
  }, [(_vm.icon == 'error') ? _c('div', {
    ref: "icon_error",
    staticClass: "sweet-modal-icon sweet-modal-error"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.icon == 'warning') ? _c('div', {
    ref: "icon_warning",
    staticClass: "sweet-modal-icon sweet-modal-warning"
  }, [_c('span', {
    staticClass: "sweet-modal-body"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-dot"
  })]) : _vm._e(), _vm._v(" "), (_vm.icon == 'info') ? _c('div', {
    ref: "icon_info",
    staticClass: "sweet-modal-icon sweet-modal-info"
  }) : _vm._e(), _vm._v(" "), (_vm.icon == 'success') ? _c('div', {
    ref: "icon_success",
    staticClass: "sweet-modal-icon sweet-modal-success"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "sweet-content-content"
  }, [_vm._t("default")], 2) : _vm._e()]), _vm._v(" "), (_vm.$slots.button) ? _c('div', {
    staticClass: "sweet-buttons"
  }, [_vm._t("button")], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sweet-modal-x-mark"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-right"
  })])
}]}

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _CommonUtils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      homeHostUrl: (0, _CommonUtils.getHomeHostUrl)(),
      trans: '',
      maskText: '',
      maskCount: 0,
      appUrl: 'javascript: void(0);'
    };
  },

  computed: {
    showLoading: function showLoading() {
      return this.$store.state.showLoading;
    }
  },
  created: function created() {
    var vm = this;
    setTimeout(function () {
      vm.trans = 'active';
    }, 100);
  },
  activated: function activated() {
    var vm = this;
    setTimeout(function () {
      vm.trans = 'active';
    }, 100);
  },
  deactivated: function deactivated() {
    this.trans = '';
  },

  methods: {
    ajax: function ajax(options) {
      var vm = this;
      var URL = options.url;
      var onSuccess = function onSuccess(response) {
        if (options.mask) {
          vm.unmask();
        }
        options.success && options.success(response);
      };
      var onError = function onError(response) {
        if (options.mask) {
          vm.unmask();
        }
        var userAgent = window.navigator.userAgent;
        var isAndroid = userAgent.indexOf('Android') > -1;
        var isIphone = userAgent.indexOf('iPhone') > -1;

        if ((response.status === 401 || response.status === 403) && !(isIphone || isAndroid)) {
          location.href = location.origin + '?os_destination=' + encodeURIComponent(location.href);
          return false;
        }
        if (options.error) {
          options.error(response);
        } else if (response.status === 0) {
          return false;
        } else {
          var message = response.data.message || '服务器发生了一个小错误，请联系下客服吧~(code: ' + response.status + ')';
          vm.$alert && vm.$alert(message, '提示');
        }
      };
      var params = options.data;
      var contentType = options.contentType;
      var isEmulateJSON = true;
      if (contentType && contentType !== 'application/x-www-form-urlencoded') {
        isEmulateJSON = false;
      }
      if (options.mask) {
        this.mask(options.maskText || '');
      }
      if (options.type === 'POST') {
        _vue2.default.http.post(URL, params, { emulateJSON: isEmulateJSON }).then(onSuccess, onError);
      } else if (options.type === 'PUT') {
        _vue2.default.http.put(URL, params, { emulateJSON: isEmulateJSON }).then(onSuccess, onError);
      } else {
        _vue2.default.http.get(URL, { params: params }).then(onSuccess, onError);
      }
    },
    mask: function mask(text) {
      this.maskText = text;
      if (this.maskCount === 0) {
        this.$store.state.showLoading = true;
      }
      this.maskCount++;
    },
    unmask: function unmask() {
      this.maskCount--;
      if (this.maskCount === 0) {
        this.$store.state.showLoading = false;
      }
      if (this.maskCount < 0) {
        this.showLoading = 0;
      }
    }
  }
};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(276);
exports.default = {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


function isLessThanIE10() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    var reg = /\d+\.0/;
    var UA = navigator.userAgent;
    var v = reg.exec(UA.split(';')[1]);
    if (v && v < 10) {
      return true;
    }
  }
  return false;
}

exports.default = {
  data: function data() {
    return {
      needUpdate: false
    };
  },
  created: function created() {
    if (isLessThanIE10()) {
      this.needUpdate = true;
    }
  }
};

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-62e088be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.needUpdate) ? _c('div', {
    staticClass: "update-mask"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "updateBrow"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', [_vm._v("你的浏览器版本太低啦，为了账户安全请使用Chrome浏览器")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chrome"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Google Chrome")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("安全")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("兼容性好")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("简洁高效")]), _vm._v(" "), _c('span', {
    staticClass: "advantage"
  }, [_vm._v("速度快")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/imgs/portal/home/Chrome_58.0.3029.110_Setup.exe",
      "id": "download",
      "title": ""
    }
  }, [_vm._v("下载正版")]), _vm._v(" "), _c('span', {
    staticClass: "suggest"
  }, [_c('span', {
    staticClass: "warn"
  }, [_vm._v("!")]), _vm._v("建议设为默认浏览器")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('p', [_vm._v("群星温馨提示：使用低版本浏览器有哪些坏处呢？")]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "safe"
    }
  }), _vm._v(" "), _c('p', [_vm._v("安全漏洞")]), _vm._v(" "), _c('span', [_vm._v("威胁账户安全")])]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "match"
    }
  }), _vm._v(" "), _c('p', [_vm._v("不兼容")]), _vm._v(" "), _c('span', [_vm._v("页面内容显示不全")])]), _vm._v(" "), _c('div', {
    staticClass: "disadvantage"
  }, [_c('div', {
    attrs: {
      "id": "pc"
    }
  }), _vm._v(" "), _c('p', [_vm._v("体验差")]), _vm._v(" "), _c('span', [_vm._v("界面排列错乱")])])])])
}]}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMainDomain = exports.initWechat = exports.getAPPUrl = exports.isMail = exports.isCellphone = exports.base64ToUtf8 = exports.utf8ToBase64 = exports.device = exports.isQQBrowser = exports.ismobile = exports.createUUID = exports.getHomeHostUrl = exports.isArrayContains = exports.getQueryString = exports.getSession = exports.win = undefined;

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _weixinJsSdk = __webpack_require__(58);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var win = {
  getLocation: function getLocation() {
    return window.location;
  }
};

function getQueryString(name, isBase64) {
  var reg = new RegExp('(^|&)' + name + '=([^&|^#]*)(&|#|$)', 'i');
  var winLocation = win.getLocation();
  if (!(winLocation.href.indexOf('?') > -1)) {
    return null;
  }
  var r = winLocation.href.split('?')[1].match(reg);
  if (r != null) {
    if (isBase64) {
      var utf8Str = '';
      try {
        utf8Str = window.atob(decodeURIComponent(r[2]));
      } catch (e) {}
      return decodeURIComponent(utf8Str);
    } else {
      return decodeURIComponent(r[2]);
    }
  }
  return null;
}

function getSession() {
  var session = null;
  var winLocation = win.getLocation();
  var sessionJson = getQueryString('json', true, winLocation);
  if (sessionJson) {
    session = JSON.parse(sessionJson);

    if (session && window.sessionStorage) {
      sessionStorage.setItem('tk', session.token);
      sessionStorage.setItem('customerId', session.customerId);
      sessionStorage.setItem('customerName', session.customerName);
      sessionStorage.setItem('userId', session.userId);
      sessionStorage.setItem('coreCustomers', (0, _stringify2.default)(session.coreCustomers));
    }
  }

  return session;
}

function getHomeHostUrl() {
  var url = 'https://www.iqunxing.com';
  var protocal = 'http://';
  var hostname = win.getLocation().hostname;
  var subDomain = hostname.split('.')[0];

  if (subDomain === 'www' || subDomain === 'wuat' || subDomain === 'wuat-3' || subDomain === 'whotfix' || subDomain === 'demo') {
    protocal = 'https://';
  }

  if (hostname === 'localhost') {
    url = win.getLocation().origin;
  } else if (subDomain === 'www') {
    url = protocal + 'home.iqunxing.com';
  } else if (subDomain === 'test1') {
    url = protocal + 'test1.iqunxing.com';
  } else if (subDomain === 'demo') {
    url = protocal + 'demoh.iqunxing.com';
  } else if (subDomain === 'wuat' || subDomain === 'whotfix' || subDomain === 'wuat-3') {
    var env = subDomain.substring(1, subDomain.length);
    var hostTarget = 'h' + env;
    url = protocal + hostTarget + '.dcfservice.com';
  } else if (subDomain.indexOf('wt') === 0) {
    var _env = subDomain.substring(1, subDomain.length);
    var _hostTarget = 'h' + _env;
    url = protocal + _hostTarget + '.dcfservice.com';
  }

  return url;
}

function isArrayContains(array, val) {
  if (array && array.length > 0) {
    for (var i = 0; i < array.length; i++) {
      if (array[i] === val) {
        return true;
      }
    }
  }

  return false;
}

function rand(max) {
  return Math.floor(Math.random() * (max + 1));
}

function returnBase(number, base) {
  return number.toString(base).toUpperCase();
}

function getIntegerBits(val, start, end) {
  var base16 = returnBase(val, 16);
  var quadArray = [];
  var quadString = '';
  var i = 0;
  for (i = 0; i < base16.length; i++) {
    quadArray.push(base16.substring(i, i + 1));
  }

  for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {
    if (!quadArray[i] || quadArray[i] === '') quadString += '0';else quadString += quadArray[i];
  }

  return quadString;
}

function createUUID() {
  var dg = new Date(1582, 10, 15, 0, 0, 0, 0);
  var dc = new Date();
  var t = dc.getTime() - dg.getTime();
  var tl = getIntegerBits(t, 0, 31);
  var tm = getIntegerBits(t, 32, 47);
  var thv = getIntegerBits(t, 48, 59) + '1';
  var csar = getIntegerBits(rand(4095), 0, 7);
  var csl = getIntegerBits(rand(4095), 0, 7);

  var n = getIntegerBits(rand(8191), 0, 7) + getIntegerBits(rand(8191), 8, 15) + getIntegerBits(rand(8191), 0, 7) + getIntegerBits(rand(8191), 8, 15) + getIntegerBits(rand(8191), 0, 15);
  return tl + tm + thv + csar + csl + n;
}

function ismobile() {
  var winWidth = window.innerWidth || document.body.clientWidth;
  return winWidth && winWidth < 736;
}

function isQQBrowser() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('qq') > -1 && ua.indexOf('mqqbrowser') < 0) {
    return true;
  }
  return false;
}

function device() {
  var device, find, userAgent;
  device = {};
  userAgent = window.navigator.userAgent.toLowerCase();

  device.ios = function () {
    return device.iphone() || device.ipod() || device.ipad();
  };

  device.iphone = function () {
    return !device.windows() && find('iphone');
  };

  device.ipad = function () {
    return find('ipad');
  };

  device.ipod = function () {
    return find('ipod');
  };

  device.android = function () {
    return !device.windows() && find('android');
  };

  device.weixin = function () {
    return !device.windows() && find('micromessenger');
  };

  device.windows = function () {
    return find('windows');
  };

  find = function find(needle) {
    return userAgent.indexOf(needle) !== -1;
  };
  return device;
}

function utf8ToBase64(utf8) {
  return window.btoa(encodeURIComponent(utf8));
}

function base64ToUtf8(base64) {
  return decodeURIComponent(window.atob(base64).replace('+', '%20'));
}

function isCellphone(number) {
  var reg = /^1\d{10}$/;
  return reg.test(number);
}

function isMail(email) {
  var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
  return reg.test(email);
}

function getAPPUrl(vm) {
  if (device().weixin()) {
    vm.appUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.dcf.qxapp';
  } else if (device().ios()) {
    vm.appUrl = 'https://itunes.apple.com/cn/app/id946253851';
  } else {
    vm.ajax({
      type: 'POST',
      url: 'https://www.iqunxing.com/mapi/corpversion@getLastVersion@v1',
      data: {
        content: {
          clientCode: 'ACBF12F9F7',
          terminalCode: 'TBF12F9F9',
          channelCode: 'CH573DF4B7'
        }
      },
      contentType: 'application/json',
      success: function success(res) {
        var content = JSON.parse(res.data.content);
        vm.appUrl = content.appURL;
      }
    });
  }
}

function isWechat() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('micromessenger') > -1) {
    return true;
  } else {
    return false;
  }
}

function initWechat(vm, logoUrl, title, desc) {
  if (!isWechat()) {
    return;
  }
  var nonceStr = 'abcdefg';
  var timestamp = new Date().getTime().toString().substring(0, 10);
  var locationUrl = location.href;
  var shareLogo = logoUrl || '';

  vm.ajax({
    url: '/services/public/mobile/getSignature',
    type: 'POST',
    data: {
      nonceStr: nonceStr,
      timestamp: timestamp,
      url: locationUrl
    },
    success: function success(resp) {
      _weixinJsSdk2.default.config({
        debug: false,
        appId: 'wx5b8b94317c7511eb',
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: resp.data.result.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
      });
    }
  });
  _weixinJsSdk2.default.ready(function () {
    var link = locationUrl;
    _weixinJsSdk2.default.onMenuShareTimeline({
      title: title || '群星',
      desc: desc || '',
      link: link,
      imgUrl: shareLogo,
      success: function success() {
        console.log('成功');
      }
    });
    _weixinJsSdk2.default.onMenuShareAppMessage({
      title: title || '群星',
      desc: desc || '',
      link: link,
      imgUrl: shareLogo,
      success: function success() {
        console.log('成功');
      }
    });
  });
}

function getMainDomain() {
  var mainDomain = null;
  var hostName = location.hostname;
  var domainSplit = hostName.split('.');
  if (domainSplit.length >= 3) {
    var sectionList = [];
    var skipStep = domainSplit.length - 2;
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i]);
    }

    mainDomain = sectionList.join('.');
  } else {
    mainDomain = 'localhost';
  }

  return mainDomain;
}

exports.win = win;
exports.getSession = getSession;
exports.getQueryString = getQueryString;
exports.isArrayContains = isArrayContains;
exports.getHomeHostUrl = getHomeHostUrl;
exports.createUUID = createUUID;
exports.ismobile = ismobile;
exports.isQQBrowser = isQQBrowser;
exports.device = device;
exports.utf8ToBase64 = utf8ToBase64;
exports.base64ToUtf8 = base64ToUtf8;
exports.isCellphone = isCellphone;
exports.isMail = isMail;
exports.getAPPUrl = getAPPUrl;
exports.initWechat = initWechat;
exports.getMainDomain = getMainDomain;

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1011)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1334),
  /* scopeId */
  "data-v-570d18a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1055)
__webpack_require__(1054)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1370),
  /* scopeId */
  "data-v-7c060d08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = exports.Portal = undefined;

var _Portal = __webpack_require__(1231);

var _Portal2 = _interopRequireDefault(_Portal);

var _Router = __webpack_require__(493);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Portal = _Portal2.default;
exports.Router = _Router2.default;

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(57);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Home = __webpack_require__(1227);

var _Home2 = _interopRequireDefault(_Home);

var _About = __webpack_require__(1223);

var _About2 = _interopRequireDefault(_About);

var _News = __webpack_require__(1229);

var _News2 = _interopRequireDefault(_News);

var _Contact = __webpack_require__(1224);

var _Contact2 = _interopRequireDefault(_Contact);

var _Join = __webpack_require__(1228);

var _Join2 = _interopRequireDefault(_Join);

var _Institution = __webpack_require__(1234);

var _Institution2 = _interopRequireDefault(_Institution);

var _Core = __webpack_require__(1233);

var _Core2 = _interopRequireDefault(_Core);

var _Chain = __webpack_require__(1232);

var _Chain2 = _interopRequireDefault(_Chain);

var _Product = __webpack_require__(1236);

var _Product2 = _interopRequireDefault(_Product);

var _Platform = __webpack_require__(1235);

var _Platform2 = _interopRequireDefault(_Platform);

var _Service = __webpack_require__(1237);

var _Service2 = _interopRequireDefault(_Service);

var _Download = __webpack_require__(1225);

var _Download2 = _interopRequireDefault(_Download);

var _OpenLogin = __webpack_require__(1230);

var _OpenLogin2 = _interopRequireDefault(_OpenLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

function $(subTitle) {
  return '群星金融' + ' - ' + subTitle;
}

var ROUTER = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: _Home2.default,
    meta: {
      title: $('首页')
    }
  }, {
    path: '/institution',
    component: _Institution2.default,
    meta: {
      title: $('角色解决方案')
    }
  }, {
    path: '/core',
    component: _Core2.default,
    meta: {
      title: $('角色解决方案')
    }
  }, {
    path: '/chain',
    component: _Chain2.default,
    meta: {
      title: $('角色解决方案')
    }
  }, {
    path: '/service',
    component: _Service2.default,
    meta: {
      title: $('供应链金融服务')
    }
  }, {
    path: '/product',
    component: _Product2.default,
    meta: {
      title: $('平台产品')
    }
  }, {
    path: '/platform',
    component: _Platform2.default,
    meta: {
      title: $('平台产品')
    }
  }, {
    path: '/about',
    component: _About2.default,
    meta: {
      title: $('关于群星')
    }
  }, {
    path: '/news',
    component: _News2.default,
    meta: {
      title: $('企业动态')
    }
  }, {
    path: '/contact',
    component: _Contact2.default,
    meta: {
      title: $('联系我们')
    }
  }, {
    path: '/join',
    component: _Join2.default,
    meta: {
      title: $('加入我们')
    }
  }, {
    path: '/download',
    component: _Download2.default,
    meta: {
      title: $('下载方案')
    }
  }, {
    path: '/openLogin/:logo',
    component: _OpenLogin2.default,
    meta: {
      title: '登录'
    }
  }]
});

ROUTER.beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

exports.default = ROUTER;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

!function (a, b, c) {
  function d(a) {
    var c = "default";a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false");var d = b.createElement("iframe"),
        e = "https://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c;e += a.style ? "&style=" + a.style : "", e += a.href ? "&href=" + a.href : "", e += "&redirect_uri=" + a.redirect_uri, d.src = e, d.frameBorder = "0", d.allowTransparency = "true", d.scrolling = "no", d.width = "300px", d.height = "400px";var f = b.getElementById(a.id);f.innerHTML = "", f.appendChild(d);
  }a.WxLogin = d;
}(window, document);
exports.default = window.WxLogin;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _messageBox = __webpack_require__(17);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _messageBox3 = __webpack_require__(36);

var _messageBox4 = _interopRequireDefault(_messageBox3);

var _carouselItem = __webpack_require__(426);

var _carouselItem2 = _interopRequireDefault(_carouselItem);

var _carouselItem3 = __webpack_require__(415);

var _carouselItem4 = _interopRequireDefault(_carouselItem3);

var _carousel = __webpack_require__(427);

var _carousel2 = _interopRequireDefault(_carousel);

var _carousel3 = __webpack_require__(416);

var _carousel4 = _interopRequireDefault(_carousel3);

var _upload = __webpack_require__(49);

var _upload2 = _interopRequireDefault(_upload);

var _upload3 = __webpack_require__(80);

var _upload4 = _interopRequireDefault(_upload3);

var _pagination = __webpack_require__(23);

var _pagination2 = _interopRequireDefault(_pagination);

var _pagination3 = __webpack_require__(51);

var _pagination4 = _interopRequireDefault(_pagination3);

var _tableColumn = __webpack_require__(24);

var _tableColumn2 = _interopRequireDefault(_tableColumn);

var _tableColumn3 = __webpack_require__(52);

var _tableColumn4 = _interopRequireDefault(_tableColumn3);

var _table = __webpack_require__(25);

var _table2 = _interopRequireDefault(_table);

var _table3 = __webpack_require__(53);

var _table4 = _interopRequireDefault(_table3);

var _option = __webpack_require__(18);

var _option2 = _interopRequireDefault(_option);

var _option3 = __webpack_require__(31);

var _option4 = _interopRequireDefault(_option3);

var _select = __webpack_require__(19);

var _select2 = _interopRequireDefault(_select);

var _select3 = __webpack_require__(32);

var _select4 = _interopRequireDefault(_select3);

var _button = __webpack_require__(11);

var _button2 = _interopRequireDefault(_button);

var _button3 = __webpack_require__(26);

var _button4 = _interopRequireDefault(_button3);

var _input = __webpack_require__(16);

var _input2 = _interopRequireDefault(_input);

var _input3 = __webpack_require__(14);

var _input4 = _interopRequireDefault(_input3);

var _col = __webpack_require__(172);

var _col2 = _interopRequireDefault(_col);

var _col3 = __webpack_require__(206);

var _col4 = _interopRequireDefault(_col3);

var _row = __webpack_require__(175);

var _row2 = _interopRequireDefault(_row);

var _row3 = __webpack_require__(209);

var _row4 = _interopRequireDefault(_row3);

var _dialog = __webpack_require__(15);

var _dialog2 = _interopRequireDefault(_dialog);

var _base = __webpack_require__(10);

var _base2 = _interopRequireDefault(_base);

var _dialog3 = __webpack_require__(35);

var _dialog4 = _interopRequireDefault(_dialog3);

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__(12);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueAwesomeSwiper = __webpack_require__(210);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

__webpack_require__(176);

var _sweetModalVue = __webpack_require__(141);

var _portal = __webpack_require__(412);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_dialog4.default);
_vue2.default.use(_row4.default);
_vue2.default.use(_col4.default);
_vue2.default.use(_input4.default);
_vue2.default.use(_button4.default);
_vue2.default.use(_select4.default);
_vue2.default.use(_option4.default);
_vue2.default.use(_table4.default);
_vue2.default.use(_tableColumn4.default);
_vue2.default.use(_pagination4.default);
_vue2.default.use(_upload4.default);
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.use(_carousel4.default);
_vue2.default.use(_carouselItem4.default);
_vue2.default.component('sweet-modal', _sweetModalVue.SweetModal);
_vue2.default.config.productionTip = false;
_vue2.default.prototype.$alert = _messageBox4.default.alert;

new _vue2.default({
  el: '#container',
  router: _portal.Router,
  template: '<Portal/>',
  components: { Portal: _portal.Portal }
});

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(33);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  hoursToLive: null,
  path: '/',
  domain: null,
  secure: false
};

function get(key) {
  var reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
  var arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

function set(key, value, options) {
  if (typeof value === 'undefined' || value === null) {
    value = '';
  }

  if (typeof options === 'undefined' || options === null) {
    options = defaultOptions;
  }

  var optionsString = assembleOptionsString(options);

  document.cookie = key + '=' + escape(value) + optionsString;
}

function resolveOptions(options) {
  var returnValue = void 0;

  if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) !== 'object' || options === null) {
    returnValue = defaultOptions;
  } else {
    returnValue = {
      hoursToLive: typeof options.hoursToLive === 'number' && options.hoursToLive !== 0 ? options.hoursToLive : defaultOptions.hoursToLive,
      path: typeof options.path === 'string' && options.path !== '' ? options.path : defaultOptions.path,
      domain: typeof options.domain === 'string' && options.domain !== '' ? options.domain : defaultOptions.domain,
      secure: typeof options.secure === 'boolean' && options.secure ? options.secure : defaultOptions.secure
    };
  }

  return returnValue;
}

function expiresGMTString(hoursToLive) {
  hoursToLive = hoursToLive || 30 * 24;
  var exp = new Date();
  exp.setTime(exp.getTime() + hoursToLive);

  return exp.toGMTString();
}

function assembleOptionsString(options) {
  options = resolveOptions(options);

  return (typeof options.hoursToLive === 'number' ? '; expires=' + expiresGMTString(options.hoursToLive) : '') + '; path=' + options.path + (typeof options.domain === 'string' ? '; domain=' + options.domain : '') + (options.secure === true ? '; secure' : '');
}

exports.default = { get: get, set: set };

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      slidRight: false
    };
  },
  created: function created() {},

  methods: {
    topage: function topage(way) {
      this.$router.push(way);
    }
  },
  components: {
    'portal-footer': _Footer2.default
  }
};

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _BaseVueOptions = __webpack_require__(2);

var _BaseVueOptions2 = _interopRequireDefault(_BaseVueOptions);

var _CookieUtils = __webpack_require__(6);

var _CookieUtils2 = _interopRequireDefault(_CookieUtils);

var _CommonUtils = __webpack_require__(3);

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _BaseVueOptions2.default,
  components: {
    'portal-footer': _Footer2.default
  },
  data: function data() {
    return {
      userName: '',
      questionType: '',
      cellphone: '',
      companyName: '',
      questionDetail: '' };
  },

  methods: {
    sendMes: function sendMes() {
      var vm = this;
      var dataObj = {
        email: 'wanglong.jin@iqunxing.com',
        cellphone: this.cellphone,
        userName: this.userName,
        companyName: this.companyName,
        questionType: this.questionType,
        questionDetail: this.questionDetail
      };
      vm.ajax({
        type: 'POST',
        url: '/api/message/scene/send',
        data: (0, _stringify2.default)({
          appId: '1048',
          code: '官网-希望联系客户信息',
          createBy: 'user',
          data: (0, _stringify2.default)(dataObj)
        }),
        success: function success(res) {
          vm.$alert('我们的顾问会在24小时内与您取得联系', '提交成功');
          vm.cellphone = '';
          vm.userName = '';
          vm.companyName = '';
          vm.questionType = '';
          vm.questionDetail = '';
        },
        error: function error(res) {
          vm.$alert('请重新填写并提交信息', '提交失败');
        }
      });
    },
    login: function login() {
      var vm = this;
      if (vm.userName === '') {
        vm.$alert('请填写联系人名字', '提示');
        return;
      }
      if (!(0, _CommonUtils.isCellphone)(vm.cellphone) && !(0, _CommonUtils.isMail)(vm.cellphone)) {
        vm.$alert('联系方式有误，请重新填写联系方式', '提示');
        return;
      }
      if (vm.questionType === '') {
        vm.$alert('请选择问题类型', '提示');
        return;
      }
      if (vm.companyName === '') {
        vm.$alert('请填写公司名称', '提示');
        return;
      }
      var param = {};
      param.cellphone = '17611405175';
      param.password = '123456yw';
      this.ajax({
        url: '/api/user/v2/public/login',
        type: 'POST',
        data: (0, _stringify2.default)(param),
        success: function success(res) {
          _CookieUtils2.default.set('tk', res.data.token, {
            domain: (0, _CommonUtils.getMainDomain)()
          });
          setTimeout(function () {
            vm.sendMes();
          }, 500);
        }
      });
    }
  }
};

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

var _ModelForm = __webpack_require__(167);

var _ModelForm2 = _interopRequireDefault(_ModelForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      page: '',
      roleType: ''
    };
  },
  created: function created() {
    this.page = this.$route.query.page ? this.$route.query.page : 'download-home';
    this.roleType = this.$route.query.roleType;
  },

  components: {
    'portal-footer': _Footer2.default,
    'portal-form': _ModelForm2.default
  }
};

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    'page': String,
    'roleType': String
  },
  methods: {
    topage: function topage(way, type) {
      this.$router.push({ path: way, query: { page: this.page, roleType: this.roleType, type: type } });
    }
  }
};

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function get(key) {
  if (window.localStorage) {
    return localStorage.getItem(key);
  }
}

function remove(key) {
  if (window.localStorage) {
    return localStorage.removeItem(key);
  }
}

function set(key, value) {
  if (window.localStorage) {
    localStorage.setItem(key, value);
  }
}

exports.default = { set: set, get: get, remove: remove };

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      caseList: ['/core', '/institution', '/chain'],
      advantageList: ['/product', '/platform', '/service'],
      aboutList: ['/about', '/news', '/join']
    };
  },

  methods: {
    topage: function topage(way) {
      this.$router.push(way);
    },
    onLogin: function onLogin() {
      location.href = '/dcf/minisite.html#/';
    }
  },
  computed: {
    currPath: function currPath() {
      return this.$route.path;
    }
  }
};

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HomeFooter = __webpack_require__(378);

var _HomeFooter2 = _interopRequireDefault(_HomeFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    Footer: _HomeFooter2.default
  },
  methods: {
    topage: function topage(way, type) {
      this.$router.push({
        path: way,
        query: { type: type }
      });
    }
  }
};

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    'page': String },
  methods: {
    topage: function topage(way, type) {
      this.$router.push({ path: way, query: { page: this.page, roleType: this.roleType, type: type } });
    }
  }
};

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HomeFooter = __webpack_require__(378);

var _HomeFooter2 = _interopRequireDefault(_HomeFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {},

  components: {
    'portal-footer': _HomeFooter2.default
  },
  data: function data() {
    return {
      teamType: 'dev'
    };
  }
};

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _LoginResolve = __webpack_require__(104);

var _LoginResolve2 = _interopRequireDefault(_LoginResolve);

var _CommonUtils = __webpack_require__(3);

var _wxLogin = __webpack_require__(494);

var _wxLogin2 = _interopRequireDefault(_wxLogin);

var _CookieUtils = __webpack_require__(6);

var _CookieUtils2 = _interopRequireDefault(_CookieUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOCK = '';

var TIME_COUNT = 60;

var LOGIN_STATUS = {
  WRONG_NAME_OR_PASSWORD: 91042201,
  WRONG_CAPTCHA: 91042002,
  LOCKED: 91042203,
  BLOCKCHAIN: 91042106
};

var REGISTER_STATUS = {
  UNREGISTER: 1,
  REGISTERED: 2,
  PRE_VERIFY: 3
};

function updateMsg(loginStatus, retryCount, vm) {
  var messages = [];

  if (loginStatus === LOGIN_STATUS.WRONG_NAME_OR_PASSWORD) {
    messages.push('用户名/手机号或密码错误');
    if (retryCount > 0 && retryCount < 4) {
      messages.push('登录次数剩余' + retryCount + '次');
    }
  } else if (loginStatus === LOGIN_STATUS.LOCKED) {
    messages.push('账号被锁定, <a href="/public/unlock.jsp?ftype=user">解锁</a>');
  } else if (loginStatus === LOGIN_STATUS.WRONG_CAPTCHA) {
    messages.push('验证码错误');
  } else if (loginStatus === LOGIN_STATUS.BLOCKCHAIN) {
    messages.push('对不起，服务正在建设中，为不影响您的使用，请下载群星APP');
  } else {
    messages.push('服务暂不可用');
  }

  if (messages.length > 0) {
    vm.errorMsg1 = messages.join('、');
    vm.errorMsg = messages.join('、');
  } else {
    vm.errorMsg1 = '';
    vm.errorMsg = '';
  }
}

function getMainDomain() {
  var mainDomain = null;
  var hostName = _CommonUtils.win.getLocation().hostname;
  var domainSplit = hostName.split('.');
  if (domainSplit.length >= 3) {
    var sectionList = [];
    var skipStep = domainSplit.length - 2;
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i]);
    }
    mainDomain = sectionList.join('.');
  } else {
    mainDomain = 'localhost';
  }
  return mainDomain;
}

exports.default = {
  extends: _LoginResolve2.default,
  data: function data() {
    return {
      registerUrl: '/minisites/registration/',
      isLogining: false,
      qrcodeLogin: false,
      step1: true,
      isShowMsg: false,
      tel1: '',
      errorMsg: '',
      isShowMsg1: false,
      errorMsg1: '',
      psw1: '',
      catpchaImg: '',
      captchaContainer: false,
      captchaCode: '',
      perCaptchaCode: '',
      step2: false,
      isShowMsg2: false,
      errorMsg2: '',
      count: '',
      timer: null,
      isShowCaptcha: true
    };
  },
  mounted: function mounted() {
    var vm = this;
    var loginResult = (0, _CommonUtils.getQueryString)('result');
    if (loginResult) {
      vm.open();
      switch (Number(loginResult)) {
        case 8:
          loginResult = 91042106;
          break;
        default:
          loginResult = 0;
          break;
      }
      vm.isShowMsg = true;
      updateMsg(loginResult, 10, this);
    }
  },

  methods: {
    getPerVerifyCaptcha: function getPerVerifyCaptcha() {
      var vm = this;
      vm.ajax({
        type: 'GET',
        url: '/api/common/v1/captcha/send/message',
        data: {
          cellPhone: vm.tel2
        },
        success: function success(data) {
          vm.getCount();
        }
      });
    },
    getCount: function getCount() {
      var _this = this;

      if (!this.timer) {
        this.count = TIME_COUNT;
        this.isShowCaptcha = false;
        this.timer = setInterval(function () {
          if (_this.count > 0 && _this.count <= TIME_COUNT) {
            _this.count--;
          } else {
            _this.isShowCaptcha = true;
            clearInterval(_this.timer);
            _this.timer = null;
          }
        }, 1000);
      }
    },
    telCaptchaFocusAction: function telCaptchaFocusAction() {
      this.isShowMsg1 = false;
      this.isShowMsg2 = false;
    },
    getCaptcha: function getCaptcha(vm) {
      vm.ajax({
        type: 'GET',
        url: '/api/common/v1/captcha/generate/graphical',
        data: {
          capthcaId: vm.tel2
        },
        success: function success(data) {
          vm.catpchaImg = 'data:image/jpeg;base64, ' + data.bodyText;
        }
      });
    },
    returnBackAction: function returnBackAction() {
      this.isShowMsg1 = false;
      this.psw1 = '';
      this.step1 = true;
      this.isShowMsg2 = false;
    },
    telChangeAction: function telChangeAction() {
      var vm = this;
      if ((0, _CommonUtils.isCellphone)(vm.tel1)) {
        vm.isShowMsg = false;
      } else {
        vm.errorMsg = '手机号码格式不正确';
        vm.isShowMsg = true;
      }
    },
    telFocusAction: function telFocusAction() {
      if (this.tel1) {
        this.isShowMsg = false;
      }
    },
    getTelState: function getTelState(tel) {
      var vm = this;
      vm.ajax({
        url: MOCK + '/api/user/v3/public/registerStatus',
        type: 'POST',
        data: (0, _stringify2.default)({
          cellphone: tel
        }),
        success: function success(res) {
          if (res.data === REGISTER_STATUS.REGISTERED) {
            vm.step1 = false;
            vm.step2 = true;
            vm.step3 = false;
            vm.tel2 = vm.tel1;
          } else if (res.data === REGISTER_STATUS.UNREGISTER) {
            var customizedLogo = (0, _CommonUtils.getQueryString)('c');
            if (customizedLogo) {
              window.open('/dcf/minisite.html?cellphone=' + vm.tel1 + '&c=' + customizedLogo);
            } else {
              window.location.href = '/dcf/minisite.html?cellphone=' + vm.tel1;
            }
          } else {
            vm.step1 = false;
            vm.step2 = false;
            vm.step3 = true;
            vm.tel2 = vm.tel1;
          }
        },
        error: function error(res) {
          vm.isShowMsg = true;
          if (res && res.data && res.data.message) {
            vm.errorMsg = res.data.message;
          } else {
            vm.errorMsg = '用户是否注册未知异常';
          }
        }
      });
    },
    telAction: function telAction() {
      var vm = this;
      if ((0, _CommonUtils.isCellphone)(vm.tel1)) {
        vm.isShowMsg = false;
        vm.getTelState(vm.tel1);
      } else {
        vm.errorMsg = '手机号码格式不正确';
        vm.isShowMsg = true;
      }
    },
    login: function login(tel, psw, captcha) {
      var param = {};
      param.cellphone = tel;
      param.password = psw;
      var vm = this;

      if (captcha) {
        param.captcha = captcha;
      }
      vm.ajax({
        url: MOCK + '/api/user/v2/public/login',
        type: 'POST',
        data: (0, _stringify2.default)(param),
        success: function success(res) {
          var content = res.data;
          var mainDomain = getMainDomain();
          _CookieUtils2.default.set('tk', content.token, {
            domain: mainDomain
          });
          vm.loginResolve(content, false);
        },
        error: function error(res) {
          vm.isShowMsg1 = true;
          if (res && res.data && res.data.code && res.data.message) {
            if (res.data.code === 91042201 || res.data.code === 91042203 || res.data.code === 91042002) {
              if (res.data.extras.tryCount) {
                vm.captchaContainer = false;
                var retryCount = 10 - res.data.extras.tryCount;
                if (retryCount <= 7) {
                  vm.getCaptcha(vm);
                  vm.captchaContainer = true;
                }
                updateMsg(res.data.code, retryCount, vm);
              } else {
                updateMsg(res.data.code, 10, vm);
              }
            } else {
              vm.errorMsg1 = res.data.message;
            }
          } else {
            vm.errorMsg1 = '登录未知异常';
          }
        }
      });
    },
    resetPassword: function resetPassword() {
      var vm = this;
      vm.ajax({
        type: 'POST',
        url: '/api/user/v2/public/resetPassword',
        data: (0, _stringify2.default)({
          cellphone: vm.tel2,
          password: vm.psw1,
          captcha: vm.perCaptchaCode
        }),
        success: function success(data) {
          vm.login(vm.tel2, vm.psw1, vm.captchaCode);
        },
        error: function error(res) {
          vm.isShowMsg2 = true;
          if (res && res.data && res.data.message) {
            vm.errorMsg2 = res.data.message;
          } else {
            vm.errorMsg2 = '用户是否注册未知异常';
          }
        }
      });
    },
    loginAction: function loginAction() {
      if (!this.step1 && !this.step2) {
        this.resetPassword();
      } else {
        this.login(this.tel2, this.psw1, this.captchaCode);
      }
    },
    open: function open(param) {
      if (this.$route.path === '/role/fund') {
        this.registerUrl = '/minisites/registration_org/';
      } else {
        this.registerUrl = '/minisites/registration/';
      }
      this.message = '';
      this.qrcodeLogin = false;
      this.$refs.loginModal.open();
      this.getQrcode();
    },
    toggleLogin: function toggleLogin() {
      this.qrcodeLogin = !this.qrcodeLogin;
    },
    getQrcode: function getQrcode() {
      var vm = this;

      vm.ajax({
        url: '/api/user/v1/public/getRandomState',
        type: 'GET',
        success: function success(res) {
          var wxOptions = {
            id: 'login-qrcode',
            scope: 'snsapi_login',
            state: res.bodyText,
            style: '',
            href: 'https://www.iqunxing.com/css/wechat-login-qr.css?v=20170630'
          };
          if (location.host !== 'www.iqunxing.com') {
            wxOptions.redirect_uri = encodeURIComponent('http://test1.iqunxing.com/open/wechat/webLogin/callback');
            wxOptions.appid = 'wx507dd1d351e50ef6';
          } else {
            wxOptions.redirect_uri = encodeURIComponent('https://home.iqunxing.com/open/wechat/webLogin/callback');
            wxOptions.appid = 'wxac2f44444a1c36ce';
          }

          var initWechatInterval = setInterval(function () {
            var loginContainer = document.getElementById('login-qrcode');
            if (_wxLogin2.default && loginContainer) {
              new _wxLogin2.default(wxOptions);
              clearInterval(initWechatInterval);
              initWechatInterval = null;
            }
          }, 500);
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
  }
};

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _CookieUtils = __webpack_require__(6);

var _CookieUtils2 = _interopRequireDefault(_CookieUtils);

var _CommonUtils = __webpack_require__(3);

var _BaseVueOptions = __webpack_require__(2);

var _BaseVueOptions2 = _interopRequireDefault(_BaseVueOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataObj = {
  email: 'wanglong.jin@iqunxing.com'
};

exports.default = {
  extends: _BaseVueOptions2.default,
  data: function data() {
    return {
      code: '',
      disabled: false,
      cellphone: '',
      userName: '',
      companyPart: '',
      companyType: '',
      industryType: '',
      companyName: '',
      institutionName: '',
      institutionPart: '' };
  },

  props: {
    from: String,
    roleType: String
  },
  created: function created() {
    this.changeCode();
  },

  watch: {
    from: function from() {
      this.changeCode();
    },
    roleType: function roleType() {
      this.changeCode();
    }
  },
  methods: {
    changeCode: function changeCode() {
      var vm = this;

      if (vm.from === 'case-core' && vm.roleType === 'N+1') {
        vm.code = '官网-N+1客户信息';
      } else if (vm.from === 'case-core' && vm.roleType === '1+N') {
        vm.code = '官网-1+N客户信息';
      } else if (vm.from === 'case-chain') {
        vm.code = '官网-留资客户信息';
      } else if (vm.from === 'case-institution') {
        vm.code = '官网-咨询机构客户信息';
      } else if (vm.from === 'download-core' && vm.roleType === 'N+1') {
        vm.code = '官网-N+1核心客户信息';
      } else if (vm.from === 'download-core' && vm.roleType === '1+N') {
        vm.code = '官网-1+N核心客户信息';
      } else if (vm.from === 'download-home') {
        vm.code = '官网-下载方案客户信息';
      } else if (vm.from === 'download-institution') {
        vm.code = '官网-下载方案金融客户信息';
      } else if (vm.from === 'product') {
        vm.code = '官网-希望体验平台产品客户信息';
        switch (vm.roleType) {
          case 'core':
            dataObj.role = '核心端';
            break;
          case 'chain':
            dataObj.role = '链属端';
            break;
          case 'institution':
            dataObj.role = '机构端';
            break;
        }
      }
    },
    login: function login() {
      var param = {};
      var vm = this;
      vm.disabled = true;
      if (vm.from.includes('download')) {
        if (!(0, _CommonUtils.isMail)(vm.cellphone)) {
          vm.$alert('邮箱地址有误，请重新填写邮箱地址', '提示');
          vm.disabled = false;
          return;
        }
      } else {
        if (!(0, _CommonUtils.isCellphone)(vm.cellphone) && !(0, _CommonUtils.isMail)(vm.cellphone)) {
          vm.$alert('联系方式有误，请重新填写联系方式', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'case-core' || vm.from === 'product') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'case-institution') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.institutionName === '') {
          vm.$alert('请填写所在金融机构名称', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'case-chain') {
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.companyPart === '') {
          vm.$alert('请选择企业角色类型', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'download-core') {
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.industryType === '') {
          vm.$alert('请选择企业行业类型', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'download-institution') {
        if (vm.institutionName === '') {
          vm.$alert('请填写所在金融机构名称', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.institutionPart === '') {
          vm.$alert('请选择金融机构类型', '提示');
          vm.disabled = false;
          return;
        }
      }
      if (vm.from === 'download-home') {
        if (vm.userName === '') {
          vm.$alert('请填写联系人名字', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.companyName === '') {
          vm.$alert('请填写公司名称', '提示');
          vm.disabled = false;
          return;
        }
        if (vm.companyType === '') {
          vm.$alert('请选择企业类型', '提示');
          vm.disabled = false;
          return;
        }
      }
      param.cellphone = '17611405175';
      param.password = '123456yw';
      vm.ajax({
        url: '/api/user/v2/public/login',
        type: 'POST',
        data: (0, _stringify2.default)(param),
        success: function success(res) {
          _CookieUtils2.default.set('tk', res.data.token, {
            domain: (0, _CommonUtils.getMainDomain)()
          });
          setTimeout(function () {
            vm.sendMes();
          }, 500);
        }
      });
    },
    sendMes: function sendMes() {
      var vm = this;
      switch (vm.code) {
        case '官网-N+1客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          break;
        case '官网-1+N客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          break;
        case '官网-留资客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userType = vm.companyPart;
          dataObj.companyName = vm.companyName;
          break;
        case '官网-咨询机构客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.institutionName;
          break;
        case '官网-N+1核心客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          dataObj.industryType = vm.industryType;
          break;
        case '官网-1+N核心客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          dataObj.industryType = vm.industryType;
          break;
        case '官网-下载方案客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          dataObj.companyType = vm.companyType;
          break;
        case '官网-下载方案金融客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.institutionPart = vm.institutionPart;
          dataObj.companyName = vm.institutionName;
          break;
        case '官网-希望体验平台产品客户信息':
          dataObj.cellphone = vm.cellphone;
          dataObj.userName = vm.userName;
          dataObj.companyName = vm.companyName;
          break;
      }
      vm.ajax({
        type: 'POST',
        url: '/api/message/scene/send',
        data: (0, _stringify2.default)({
          appId: '1048',
          code: vm.code,
          createBy: 'user',
          data: (0, _stringify2.default)(dataObj)
        }),
        success: function success(res) {
          dataObj = { email: 'wanglong.jin@iqunxing.com' };
          vm.$alert('提交成功', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              vm.disabled = false;
              location.reload();
            }
          });
        },
        error: function error(res) {
          vm.disabled = false;
        }
      });
    }
  }
};

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    'portal-footer': _Footer2.default
  },
  methods: {}
};

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalLogin = __webpack_require__(379);

var _ModalLogin2 = _interopRequireDefault(_ModalLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _ModalLogin2.default
};

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseVueOptions = __webpack_require__(2);

var _BaseVueOptions2 = _interopRequireDefault(_BaseVueOptions);

var _Header = __webpack_require__(1226);

var _Header2 = _interopRequireDefault(_Header);

var _UpdateModal = __webpack_require__(282);

var _UpdateModal2 = _interopRequireDefault(_UpdateModal);

var _CommonUtils = __webpack_require__(3);

__webpack_require__(808);

__webpack_require__(809);

__webpack_require__(814);

__webpack_require__(817);

__webpack_require__(818);

__webpack_require__(812);

__webpack_require__(815);

__webpack_require__(813);

__webpack_require__(816);

__webpack_require__(810);

__webpack_require__(811);

__webpack_require__(741);

__webpack_require__(799);

__webpack_require__(819);

__webpack_require__(820);

__webpack_require__(780);

__webpack_require__(781);

__webpack_require__(782);

__webpack_require__(783);

__webpack_require__(786);

__webpack_require__(784);

__webpack_require__(785);

__webpack_require__(787);

__webpack_require__(788);

__webpack_require__(789);

__webpack_require__(790);

__webpack_require__(792);

__webpack_require__(791);

__webpack_require__(779);

__webpack_require__(807);

__webpack_require__(767);

__webpack_require__(777);

__webpack_require__(776);

__webpack_require__(772);

__webpack_require__(773);

__webpack_require__(771);

__webpack_require__(768);

__webpack_require__(770);

__webpack_require__(775);

__webpack_require__(769);

__webpack_require__(766);

__webpack_require__(774);

__webpack_require__(778);

__webpack_require__(740);

__webpack_require__(804);

__webpack_require__(802);

__webpack_require__(800);

__webpack_require__(805);

__webpack_require__(806);

__webpack_require__(801);

__webpack_require__(803);

__webpack_require__(794);

__webpack_require__(795);

__webpack_require__(796);

__webpack_require__(798);

__webpack_require__(797);

__webpack_require__(738);

__webpack_require__(739);

__webpack_require__(734);

__webpack_require__(737);

__webpack_require__(736);

__webpack_require__(735);

__webpack_require__(257);

__webpack_require__(760);

__webpack_require__(761);

__webpack_require__(763);

__webpack_require__(762);

__webpack_require__(759);

__webpack_require__(765);

__webpack_require__(764);

__webpack_require__(742);

__webpack_require__(743);

__webpack_require__(744);

__webpack_require__(745);

__webpack_require__(746);

__webpack_require__(747);

__webpack_require__(748);

__webpack_require__(749);

__webpack_require__(750);

__webpack_require__(751);

__webpack_require__(753);

__webpack_require__(752);

__webpack_require__(754);

__webpack_require__(755);

__webpack_require__(756);

__webpack_require__(757);

__webpack_require__(758);

__webpack_require__(821);

__webpack_require__(824);

__webpack_require__(822);

__webpack_require__(823);

__webpack_require__(826);

__webpack_require__(825);

__webpack_require__(829);

__webpack_require__(828);

__webpack_require__(827);

__webpack_require__(1095);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPageNavBarSettings(path) {
  var settings = {};
  settings.navTitle = document.title;
  if (path) {
    if (path.indexOf('/industrySolution') !== -1) {
      settings.target = 'by-industry';
    } else if (path.indexOf('/role') !== -1) {
      settings.target = 'by-role';
    } else if (path.indexOf('/productSolution') !== -1) {
      settings.target = 'by-product';
    } else {
      settings.target = '';
    }
  }

  return settings;
}

var subMenu = {
  role: {
    classification: '按角色查看',
    subTitle: [{
      title: '核心企业',
      link: '/role/core'
    }, {
      title: '供应商',
      link: '/role/supplier'
    }, {
      title: '经销商',
      link: '/role/dealer'
    }, {
      title: '资金方',
      link: '/role/fund'
    }]
  },
  product: {
    classification: '按产品查看',
    subTitleClass: 'product',
    subTitle: [{
      title: '虚拟财务公司',
      link: '/productSolution/virtualFinanceCompany'
    }, {
      title: '供应商应收账款融资(N+1)',
      link: '/productSolution/supplier'
    }, {
      title: '核心企业应收账款卖断(1+N)',
      link: '/productSolution/core'
    }, {
      title: 'DPP(动态提前付款)',
      link: '/productSolution/investment'
    }, {
      title: '星金券',
      link: '/productSolution/bond'
    }]
  },
  industrySolution: {
    classification: '按行业查看',
    subTitle: [{
      title: '零售行业',
      link: '/industrySolution/retail'
    }, {
      title: '医药流通行业',
      link: '/industrySolution/medicine'
    }, {
      title: '汽配行业',
      link: '/industrySolution/auto'
    }, {
      title: 'IT分销行业',
      link: '/industrySolution/it'
    }, {
      title: '服饰行业',
      link: '/industrySolution/dress'
    }, {
      title: '物流行业',
      link: '/industrySolution/logistics'
    }, {
      title: '制造行业',
      link: '/industrySolution/manufacture'
    }]
  }
};

exports.default = {
  extends: _BaseVueOptions2.default,
  components: {
    Header: _Header2.default,
    'modal-login': function modalLogin(resolve) {
      new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(379)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    'update-modal': _UpdateModal2.default
  },
  data: function data() {
    return {
      registerUrl: location.hash === '#/role/fund' ? '/minisites/registration_org/' : '/minisites/registration/',
      subMenuPath: '',
      subMenuShowPath: '',
      currentUrl: '',
      menus: [{
        label: '首页',
        link: '/'
      }, {
        label: '产品及解决方案',
        link: 'javascript:',
        class: '/solutions',
        subMenu: subMenu
      }, {
        label: '关于群星',
        link: '/about'
      }, {
        label: '企业动态',
        link: '/news'
      }, {
        label: '联系我们',
        link: '/contact'
      }, {
        label: '群星app',
        link: '/download'
      }]
    };
  },
  created: function created() {
    if (this.$route.path.indexOf('/openLogin') === 0) {
      return;
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.includes('iphone') || ua.includes('android')) {
      location.href = 'mobile.html';
    }
    var pageNavBarSettings = getPageNavBarSettings();
    this.navTitle = pageNavBarSettings.navTitle;
    this.currentUrl = location.hash;
    this.updateMenuState(location.hash);
  },

  watch: {
    '$route': function $route(to, from) {
      var pageNavBarSettings = getPageNavBarSettings(to.path);
      var currentUrl = location.hash;
      this.currentUrl = currentUrl;
      this.updateMenuState(currentUrl);
      if (to.matched.length > 0) {
        this.navTitle = pageNavBarSettings.navTitle;
        this.updateSubMenuPath(pageNavBarSettings.target);
        window.scrollTo(0, 0);
      } else {
        location.href = '/#/';
      }
    }
  },
  methods: {
    updateMenuState: function updateMenuState(currentUrl) {
      if (currentUrl.indexOf('/industrySolution/') > -1 || currentUrl.indexOf('/role/') > -1 || currentUrl.indexOf('/productSolution/') > -1) {
        this.menus[1].class = 'router-link-active';
        if (currentUrl.indexOf('/industrySolution/') > -1) {
          this.subMenuPath = 'by-industry';
          this.subMenuShowPath = 'by-industry';
        } else if (currentUrl.indexOf('/role/') > -1) {
          this.subMenuPath = 'by-role';
          this.subMenuShowPath = 'by-role';
        } else if (currentUrl.indexOf('/productSolution/') > -1) {
          this.subMenuPath = 'by-product';
          this.subMenuShowPath = 'by-product';
        }
      } else {
        this.menus[1].class = '';
        this.subMenuPath = '';
      }
    },
    showLoginModal: function showLoginModal(param) {
      if ((0, _CommonUtils.ismobile)()) {
        if (param === 'org') {
          location.href = '/m/org.html';
        } else {
          this.$router.push({
            path: '/download'
          });
        }
      } else {
        this.$refs.loginModal.open(param);
      }
    },
    openQQ: function openQQ() {
      window.open('http://wpa.b.qq.com/cgi/wpa.php?ln=2&uin=800002432', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');
    },
    updateSubMenuPath: function updateSubMenuPath(target) {
      var vm = this;
      if (target === 'back') {
        if (vm.subMenuPath === 'by-classification') {
          vm.subMenuPath = '';
          vm.subMenuShowPath = '';
        } else {
          vm.subMenuPath = 'by-classification';
          setTimeout(function () {
            vm.subMenuShowPath = 'by-classification';
          }, 300);
        }
      } else {
        vm.subMenuPath = target;
        vm.subMenuShowPath = target;
      }
    }
  }
};

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

var _ModelForm = __webpack_require__(167);

var _ModelForm2 = _interopRequireDefault(_ModelForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      active: 'N+1'
    };
  },
  created: function created() {
    this.active = this.$route.query.type === 'n1' || !this.$route.query.type ? 'N+1' : '1+N';
  },

  watch: {
    $route: function $route(to) {
      this.active = to.query.type === 'n1' || !to.query.type ? 'N+1' : '1+N';
    }
  },
  components: {
    'portal-footer': _Footer2.default,
    'portal-form': _ModelForm2.default
  }
};

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

var _ModelForm = __webpack_require__(167);

var _ModelForm2 = _interopRequireDefault(_ModelForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      active: 'N+1'
    };
  },
  created: function created() {
    this.active = this.$route.query.type === 'n1' || !this.$route.query.type ? 'N+1' : '1+N';
  },
  mounted: function mounted() {
    if (this.$route.query.type === 'form') {
      this.scrollToForm();
    }
  },

  components: {
    'portal-footer': _Footer2.default,
    'portal-form': _ModelForm2.default
  },
  methods: {
    topage: function topage(way, page) {
      this.$router.push({ path: way, query: { page: page, roleType: this.active } });
    },
    scrollToForm: function scrollToForm() {
      window.scrollTo(0, 1530);
    }
  }
};

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

var _ModelForm = __webpack_require__(167);

var _ModelForm2 = _interopRequireDefault(_ModelForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      active: 'N+1'
    };
  },
  mounted: function mounted() {
    if (this.$route.query.type === 'form') {
      this.scrollToForm();
    }
  },

  components: {
    'portal-footer': _Footer2.default,
    'portal-form': _ModelForm2.default
  },
  methods: {
    scrollToForm: function scrollToForm() {
      window.scrollTo(0, 1682);
    },
    topage: function topage(way, page) {
      this.$router.push({ path: way, query: { page: page } });
    }
  }
};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

var _ModelForm = __webpack_require__(167);

var _ModelForm2 = _interopRequireDefault(_ModelForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {
    this.roletype = this.$route.query.role;
  },

  components: {
    'portal-footer': _Footer2.default,
    'portal-form': _ModelForm2.default
  },
  methods: {
    upImg: function upImg(type) {
      console.log(type);
    },
    downImg: function downImg(type) {
      console.log(type);
    }
  },
  data: function data() {
    return {
      loop: false,
      roletype: 'core',
      institutionProduct: 'products',
      coreProduct: 'operator' };
  }
};

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {},

  components: {
    'portal-footer': _Footer2.default
  },
  methods: {
    topage: function topage(way, query) {
      this.$router.push({
        path: way,
        query: {
          role: query
        }
      });
    }
  },
  data: function data() {
    return {
      coreShow: 'platform',
      institutionShow: 'product'
    };
  }
};

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Footer = __webpack_require__(78);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  created: function created() {},

  components: {
    'portal-footer': _Footer2.default
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(962)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1294),
  /* scopeId */
  "data-v-3a30e732",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 906:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 909:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[500]);


// WEBPACK FOOTER //
// js/index.66b141afa22587420c0e.js